<style lang="less" scoped>
.image-preview {
  margin-top: 10px;
}

.ivu-tabs-tabpane {
  .ivu-row {
    margin: 0 !important;
  }
}

.footer {
  margin-top: 30px;
  text-align: right;

  .cancel {
    margin-right: 10px;
  }
}

.common-upload {
  display: inline-block
}

table {
  border-collapse: collapse;

  thead, tr {
    border-bottom: 1px solid #e0e0e0;
  }
}

table {
  border-collapse: collapse;

  thead, tr {
    border-bottom: 1px solid #e0e0e0;
  }
}

.table {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-spacing: 0;
  border-collapse: collapse;

  tbody {
    td {
      position: relative;
      height: 40px;
    }
  }

  .seperator {
    background: #00AAEE;
    height: 10px;
  }
}

.table-container {
  border: 1px solid #e0e0e0;
}

.table-wrapper {
  max-height: none;
  overflow-y: visible;
  border: 1px solid #e0e0e0;
  position: relative;
}

.search-fixed {
  padding-bottom: 10px;
}

.search-wrapper {
  position: relative;
  z-index: 1;
}

.table {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-spacing: 0;
  border-collapse: collapse;
  margin-bottom: 20px; // 表格之间的间距

  thead {
    background: #ffffff;
  }

  tbody {
    td {
      position: relative;
      height: 40px;
    }
  }

  .seperator {
    background: #00AAEE;
    height: 10px;
  }
}

// Tab 内容区域滚动容器
.ivu-tabs-content {
  position: relative;
}

.ivu-tabs-tabpane {
  .ivu-row {
    margin: 0 !important;
  }
}

// Modal 内容区域不需要特殊设置
.ivu-modal-content {
  // 自然滚动，无需特殊设置
}

.ivu-checkbox-group {
  text-align: right;
}

.color {
  width: 14px;
  height: 14px;
  display: inline-block;
  vertical-align: middle;
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
  line-height: 1;
  position: relative;
}

.state-available {
  color: #2f9d4f;
  font-weight: 600;
}

.state-unsure {
  color: #f0ad4e;
  font-weight: 600;
}

.state-unavailable {
  color: #d9534f;
  font-weight: 600;
}

.state-empty {
  color: #ccc;
  font-weight: 400;
}

.course-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
  margin-top: 10px;
}

.course-row {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.course-row:last-child {
  border-bottom: none;
}

.course-header {
  background-color: #f5f5f5;
  font-weight: 600;
}

.course-cell {
  flex: 1;
  padding: 10px;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.course-cell:last-child {
  border-right: none;
}

.course-cell.time-slot {
  flex: 0 0 140px;
  font-weight: 500;
  background-color: #fafafa;
}

.course-cell.selectable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.course-cell.selectable:hover {
  background-color: #f0f0f0;
}

.course-tip {
  display: block;
  margin: 10px 0;
  padding: 8px 12px;
  background-color: #f0f9ff;
  border-left: 3px solid #00AAEE;
  color: #666;
  font-size: 13px;
}

.stat-tab {
  padding: 8px 4px 0;
}

.stat-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.stat-week-hint {
  margin-left: 12px;
  color: #808695;
  font-size: 12px;
}

.stat-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
}

.stat-card {
  width: 33.33%;
  box-sizing: border-box;
  padding: 16px 8px 20px;
  text-align: center;
  background: #fff;
}

.stat-card.is-clickable {
  cursor: pointer;
}

.stat-card.is-clickable:hover {
  background: #f8f8f9;
}

.stat-card-title {
  color: #808695;
  font-size: 13px;
  line-height: 1.4;
}

.stat-card-value {
  margin: 8px 0 4px;
  color: #17233d;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.stat-card-sub {
  color: #808695;
  font-size: 12px;
}

.stat-card-foot {
  margin-top: 6px;
  color: #808695;
  font-size: 12px;
  line-height: 1.5;
  text-align: left;
}

.stat-foot {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #e8eaec;
  color: #808695;
  font-size: 12px;
  text-align: right;
}

.onboarding-tab {
  padding: 8px 4px 0;
}

.onboarding-head {
  margin-bottom: 12px;
}

.onboarding-progress {
  color: #2dadff;
}

.onboarding-version {
  margin-left: 12px;
  color: #808695;
}
</style>
<template>
  <div>
    <Modal title="老师基本信息" v-model="visible" width="1000px" v-drag-modal>
      <Tabs type="card" :animated="false" :key="tabBarKey" @on-click="onTabClick" v-model="tabName">
        <Tab-pane label="基本信息" name="基本信息">
          <Form ref="tchForm" class="form" :model="formData" :rules="tchRule">
            <Row span="24">
              <i-col span="12">
                <Row>
                  <Tag style="margin:0 0 20px 20px" color="yellow">基本信息</Tag>
                </Row>
                <Row align="middle">
                  <i-col span="12">
                    <Row>
                      <i-col>
                        <Form-item :label-width="100" label="First Name：" prop="firstName">
                          <Input v-model="formData.firstName"></Input>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row>
                      <i-col>
                        <Form-item :label-width="100" label="Last Name：" prop="lastName">
                          <Input v-model="formData.lastName"></Input>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row>
                      <i-col>
                        <Form-item :label-width="80" label="Full Name：" prop="fullName">
                          <Input v-model="formData.tchForm.fullName"></Input>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row>
                      <i-col>
                        <Form-item :label-width="90" label="注册渠道：">
                          <Select v-model="formData.tchForm.regFrom" placeholder="请选择" clearable transfer>
                            <Option v-for="item in enabledChannelOptions" :value="item.param" :key="item.id">{{ item.name }}</Option>
                          </Select>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row>
                      <i-col>
                        <Form-item :label-width="80" label="密码：" :required="isAddTch">
                          <Input v-model="formData.newPassword"/>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row>
                      <i-col span="20">
                        <Form-item :label-width="80" label="性别：" prop="sex">
                          <Select v-model="formData.sex" transfer>
                            <Option v-for="item in $constant.sex"
                                    :value="item.code" :key="item.code">{{ item.text }}
                            </Option>
                          </Select>
                        </Form-item>
                      </i-col>

                    </Row>
                  </i-col>
                  <i-col span="8" offset="3">
                    <a @click="redirectToTchSystem"><img :src="totalImageUrl" style="width: 120px;height: 120px"></a>
                    <single-one-pic-upload @on-file-change="handleResult" :text="text"/>
                  </i-col>
                  <i-col span="10">
                    <Form-item :label-width="80" label="来源：" prop="channel">
                      <Select v-model="formData.channel" transfer>
                        <Option v-for="item in $constant.tchChannel"
                                :value="item.code" :key="item.code">{{ item.text }}
                        </Option>
                      </Select>
                    </Form-item>
                  </i-col>
                </Row>
                <Row>
                  <i-col span="10" v-if="showBirthday">
                    <Form-item :label-width="80" label="生日：" prop="birthday">
                      <Input type="date" name="birthday" v-model="formData.birthday" @on-change="onBirthdayChange"></Input>
                    </Form-item>
                  </i-col>
                  <i-col span="10">
                    <Form-item :label-width="80" label="期望时薪：" prop="channel">
                        <Input name="salary" v-model="formData.tchForm.expectSalary" @on-blur="validateNumericField(formData.tchForm, 'expectSalary')"></Input>
                    </Form-item>
                  </i-col>
                  <i-col span="12">
                    <Form-item :label-width="80" label="学历：">
                      <Input name="eduLevel" v-model="formData.eduLevel" placeholder="例如：本科"></Input>
                    </Form-item>
                  </i-col>
                  <i-col span="12">
                    <Form-item :label-width="80" label="合同：">
                      <a @click="editContract()">查看合同</a>
                    </Form-item>
                  </i-col>
                </Row>
                <Row>
                  <i-col span="12">
                    <Form-item :label-width="80" label="国籍：">
                      <Input name="country" v-model="formData.country"></Input>
                    </Form-item>
                  </i-col>
                  <i-col span="11">
                    <Form-item :label-width="80" label="口音：">
                      <Select v-model="formData.accent" transfer>
                        <Option v-for="item in $constant.accent"
                                :value="item.code" :key="item.code">{{ item.text }}
                        </Option>
                      </Select>
                    </Form-item>
                  </i-col>
                </Row>
                <Row>
                  <i-col span="11"  v-if="!isAddTch || saveType === 'agency'">
                    <Form-item :label-width="80" label="类型：" prop="category">
                      <Select v-model.number="formData.category" transfer :disabled="isAddTch && saveType === 'agency'">
                        <Option v-for="item in $constant.teacherCategory"
                                :value="item.code" :key="item.code">{{ item.text }}
                        </Option>
                      </Select>
                    </Form-item>
                  </i-col>
                  <i-col span="11">
                    <Form-item :label-width="80" label="年龄：" prop="age">
                      <InputNumber :max="100" :min="1" v-model="formData.age" @on-change="onAgeChange"/>
                    </Form-item>
                  </i-col>
                </Row>
                <Row>
                  <i-col span="12" v-if="canEdit">
                    <Form-item :label-width="80" :label="formData.tchChannel === 1 ? '时薪：' : '时薪：'">
                      <Input name="salary" v-model="formData.salary" @on-blur="validateNumericField(formData, 'salary')" style="width: 120px"></Input>
                      <span style="margin-left: 8px; color: #666;">对外展示</span>
                      <i-switch v-model="formData.tchForm.showSalary" size="small" style="margin-left: 4px"></i-switch>
                    </Form-item>
                  </i-col>
                  <i-col span="11" v-if="!isAddTch">
                    <Form-item :label-width="80" label="授课类型：" prop="tchType">
                      <Select v-model.number="formData.tchType" transfer>
                        <Option v-for="item in $constant.tchType"
                                :value="item.code" :key="item.code">{{ item.text }}
                        </Option>
                      </Select>
                    </Form-item>
                  </i-col>
                </Row>

                <Row>
                  <i-col span="12">
                    <Form-item :label-width="100" label="合同开始时间：">
                      <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                                   @on-change="crtBeginTimeDateChange" v-model="formData.crtBeginTime"/>

                    </Form-item>
                  </i-col>


                  <i-col span="12">
                    <Form-item :label-width="100" label="合同结束时间：">
                      <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                                   @on-change="crtEndTimeDateChange" v-model="formData.crtEndTime"/>

                    </Form-item>
                  </i-col>
                </Row>


                <Row>
                  <i-col span="12">
                    <Form-item :label-width="100" label="介绍视频：">
                      <el-upload
                        class="upload-demo"
                        :action="$appConfig.baseUrl + '/upload/fileUpload'"
                        :on-change="handleIntroduceVideoUrl"
                        :on-success="IntroduceVideoUrlSuccess"
                        :on-progress="handleProgress"
                        :headers="headers"
                        :before-upload="beforeUploadIntroduceVideoUrl"
                        accept="video/*"
                        :limit="2"
                        multiple
                        :file-list="introduceVideoUrlList">
                        <el-tooltip class="item" effect="light" content="不得超过500M" placement="top">
                          <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                        </el-tooltip>
                      </el-upload>
                      <!--<single-one-pic-upload @on-file-change="handleIntroduceVideoUrl" :text="uploadText" accept="video/*"/>-->
                      <a @click="openImage(introduceVideoUrl)" v-if="introduceVideoUrl">查看</a>
                      <a @click="deleteUrl('VIDEO')" v-if="introduceVideoUrl">删除</a>
                    </Form-item>
                  </i-col>

                  <i-col span="12" v-if="formData.editPermission">
                    <Form-item :label-width="100" label="国籍图片：">
                      <el-upload
                        class="upload-demo"
                        :action="$appConfig.baseUrl + '/upload/fileUpload'"
                        :on-change="handleNationalityImageChange"
                        :on-success="nationalityImageSuccess"
                        :on-remove="nationalityImageRemove"
                        :on-progress="handleProgress"
                        :headers="headers"
                        :before-upload="beforeUploadNationalityImage"
                        accept="image/*"
                        :limit="1"
                        :file-list="nationalityImageUrlList">
                        <el-tooltip class="item" effect="light" content="不得超过30M" placement="top">
                          <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                        </el-tooltip>
                      </el-upload>
                      <div class="image-preview" v-if="nationalityImageUrl">
                        <viewer>
                          <img :src="nationalityImageUrl" style="width: 100px; height: 100px; margin-top: 10px; cursor: pointer;" alt="国籍图片预览">
                        </viewer>
                      </div>
                      <a @click="openImage(nationalityImageUrl)" v-if="nationalityImageUrl">查看</a>
                      <a @click="deleteUrl('NATIONALITY_IMAGE')" v-if="nationalityImageUrl">删除</a>
                    </Form-item>
                  </i-col>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="上课片段：">
                    <el-upload
                      class="upload-demo"
                      :action="$appConfig.baseUrl + '/upload/fileUpload'"
                      :on-change="handleTeachVideo"
                      :on-success="teachVideoSuccess"
                      :headers="headers"
                      :before-upload="beforeUploadTeachVideo"
                      :on-progress="handleProgress"
                      :limit="2"
                      multiple
                      :file-list="teachVideoList">
                      <el-tooltip class="item" effect="light" content="不得超过500M" placement="top">
                        <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                      </el-tooltip>
                    </el-upload>
                  </Form-item>
                  <Form-item :label-width="100">
                    <li v-for="(item,index) in teachVideoList">
                      <a @click="openImage(item)" v-show="item">查看</a>
                      <!--                  <a @click="deleteUrl('TEACHVIDEO')" v-show="item">删除</a>-->
                    </li>
                  </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="外教介绍：">
                    <Input v-model="formData.sign" type="textarea" :maxlength="500"
                           :autosize="{minRows: 1,maxRows: 10}"/>
                  </Form-item>
                </Row>
              </i-col>
              <i-col span="12">
                <Row>
                  <Tag style="margin:0 0 20px 20px" color="yellow">教学属性</Tag>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="老师上传：" v-if="canEdit && showTchSelf">
                    <i-col>
                      <Row>
                        <i-col>
                          <Form-item label="TESOL：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleTESOL"
                              :on-success="TESOLSuccess"
                              :headers="headers"
                              :on-progress="handleProgress"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="certificateTesolUrlList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleTESOL" :text="uploadText" />-->
                          <a @click="openImage(certificateTesolUrl)" v-if="certificateTesolUrl">查看</a>
                          <a @click="deleteUrl('TESOL')" v-if="certificateTesolUrl">删除</a>
                        </i-col>
                        <i-col>
                          <Form-item label="TEFL：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleTEFL"
                              :on-success="TEFLSuccess"
                              :on-progress="handleProgress"
                              :headers="headers"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="certificateTeflUrlList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleTEFL" :text="uploadText" />-->
                          <a @click="openImage(certificateTeflUrl)" v-if="certificateTeflUrl">查看</a>
                          <a @click="deleteUrl('TEFL')" v-if="certificateTeflUrl">删除</a>
                        </i-col>
                        <i-col>
                          <Form-item label="英语专业：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleEnglish"
                              :on-success="EnglishSuccess"
                              :on-progress="handleProgress"
                              :headers="headers"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="certificateEnglishUrlList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleEnglish" :text="uploadText" />-->
                          <a @click="openImage(certificateEnglishUrl)" v-if="certificateEnglishUrl">查看</a>
                          <a @click="deleteUrl('ENGLISH')" v-if="certificateEnglishUrl">删除</a>
                        </i-col>
                      </Row>
                      <Row>
                        <i-col>
                          <Form-item label="简历：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleResume"
                              :on-success="resumeSuccess"
                              :on-progress="handleProgress"
                              :headers="headers"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="resumeList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleResume" :text="uploadText" />-->
                          <a @click="openImage(resume)" v-if="resume">查看</a>
                          <a @click="deleteUrl('RESUME')" v-if="resume">删除</a>
                        </i-col>
                        <i-col>
                          <Form-item label="自我介绍视频：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleSelfIntroductionVideo"
                              :on-success="selfIntroductionVideoSuccess"
                              :headers="headers"
                              :before-upload="beforeUploadIntroductionVideo"
                              :on-progress="handleProgress"
                              :limit="2"
                              multiple
                              :file-list="selfIntroductionVideoList">
                              <el-tooltip class="item" effect="light" content="不得超过500M" placement="top">
                                <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                              </el-tooltip>
                            </el-upload>
                          </Form-item>
                          <a @click="openImage(selfIntroductionVideo)" v-show="selfIntroductionVideo">查看</a>
                          <a @click="deleteUrl('SELFINTRODUCTIONVIDEO')" v-show="selfIntroductionVideo">删除</a>
                        </i-col>
                      </Row>
                    </i-col>
                  </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="对外展示：">
                    <i-col>
                      <Row>
                        <i-col>
                          <Form-item label="TESOL：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleTESOLOut"
                              :on-success="TESOLOutSuccess"
                              :on-progress="handleProgress"
                              :headers="headers"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="certificateTesolOutUrlList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleTESOLOut" :text="uploadText" />-->
                          <a @click="openImage(certificateTesolOutUrl)" v-if="certificateTesolOutUrl">查看</a>
                          <a @click="deleteUrl('TESOLOut')" v-if="certificateTesolOutUrl">删除</a>
                        </i-col>
                        <i-col>
                          <Form-item label="TEFL：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleTEFLOut"
                              :on-success="TEFLOutSuccess"
                              :on-progress="handleProgress"
                              :headers="headers"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="certificateTeflOutUrlList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleTEFLOut" :text="uploadText" />-->
                          <a @click="openImage(certificateTeflOutUrl)" v-if="certificateTeflOutUrl">查看</a>
                          <a @click="deleteUrl('TEFLOut')" v-if="certificateTeflOutUrl">删除</a>
                        </i-col>
                      </Row>
                      <Row>
                        <i-col>
                          <Form-item label="TEYL：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleTEYL"
                              :on-success="TEYLSuccess"
                              :on-progress="handleProgress"
                              :headers="headers"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="certificateTeylUrlList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleTEYL" :text="uploadText" />-->
                          <a @click="openImage(certificateTeylUrl)" v-if="certificateTeylUrl">查看</a>
                          <a @click="deleteUrl('TEYL')" v-if="certificateTeylUrl">删除</a>
                        </i-col>
                        <i-col>
                          <Form-item label="英语专业：">
                            <el-upload
                              class="upload-demo"
                              :action="$appConfig.baseUrl + '/upload/fileUpload'"
                              :on-change="handleEnglishOut"
                              :on-success="EnglishOutSuccess"
                              :on-progress="handleProgress"
                              :headers="headers"
                              :before-upload="beforeUpload"
                              :limit="2"
                              multiple
                              :file-list="certificateEnglishOutUrlList">
                              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                            </el-upload>
                          </Form-item>
                          <!--<single-one-pic-upload @on-file-change="handleEnglish" :text="uploadText" />-->
                          <a @click="openImage(certificateEnglishOutUrl)" v-if="certificateEnglishOutUrl">查看</a>
                          <a @click="deleteUrl('ENGLISHOut')" v-if="certificateEnglishOutUrl">删除</a>
                        </i-col>
                      </Row>
                    </i-col>
                  </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="教学经验：">
                    <Select v-model="formData.experience" transfer style="width: 220px">
                      <Option v-for="i in 20" :value="String(i)" :key="i">{{ i }}</Option>
                    </Select>
                  </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="教学特色：">
                    <CheckboxGroup v-model="featuresArray">
                      <Checkbox label="1">会中文</Checkbox>
                      <Checkbox label="2">长的好看</Checkbox>
                      <Checkbox label="3">道具多</Checkbox>
                      <Checkbox label="4">活泼</Checkbox>
                      <Checkbox label="5">TPR优秀</Checkbox>
                      <Checkbox label="6">在中国教过书</Checkbox>
                      <Checkbox label="7">会板书</Checkbox>
                      <Checkbox label="8">会拓展</Checkbox>
                      <Checkbox label="99">其他</Checkbox>
                    </CheckboxGroup>
                  </Form-item>
                </Row>

                <Row>
                  <Form-item :label-width="100" label="适宜级别：">
                    <CheckboxGroup v-model="levelArray">
                      <Checkbox label="1">Level1</Checkbox>
                      <Checkbox label="5">Level2</Checkbox>
                      <Checkbox label="2">Level3-Level5</Checkbox>
                      <Checkbox label="3">Level6-Level9</Checkbox>
                      <Checkbox label="4">Wonders及其他</Checkbox>
                      <Checkbox label="6">PU</Checkbox>
                    </CheckboxGroup>
                  </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="在线简历：">
                    <a @click="openDetailLink()" v-if="formData.id">老师简历(网页版)</a>
                  </Form-item>
                  <Form-item :label-width="160" label="磨课视频/优秀上课展示：">
                    <div v-for="(url,index) in polishLessonVideoList" :key="'polish-'+index" style="margin-bottom:6px">
                      <Input v-model="polishLessonVideoList[index]" placeholder="粘贴文件地址" style="width:280px"></Input>
                      <a @click="openImage(url)" v-show="url" style="margin-left:8px">查看</a>
                      <i v-if="index === polishLessonVideoList.length - 1 && polishLessonVideoList.length < 10"
                         class="el-icon-circle-plus-outline"
                         @click="addPolishLessonVideoRow"
                         style="font-size:20px;margin-left:8px;cursor:pointer;color:#0ABB08;"></i>
                    </div>
                  </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="老师介绍：">
                    <el-upload
                      class="upload-demo"
                      :action="$appConfig.baseUrl + '/upload/fileUpload'"
                      :on-change="handleIntroduceDoc"
                      :on-success="IntroduceDocSuccess"
                      :on-progress="handleProgress"
                      :headers="headers"
                      accept="application/*"
                      :before-upload="beforeUpload"
                      :limit="2"
                      multiple
                      :file-list="introduceDocUrlList">
                      <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                    </el-upload>
                    <!--<single-one-pic-upload @on-file-change="handleIntroduceDoc" :text="uploadText" accept="application/*"/>-->
                    <a @click="openImage(introduceDocUrl)" v-if="introduceDocUrl">查看</a>
                    <a @click="deleteUrl('DOC')" v-if="introduceDocUrl">删除</a>
                  </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="风采展示(照片)：">
                    <el-upload
                      class="upload-demo"
                      :action="$appConfig.baseUrl + '/upload/fileUpload'"
                      :on-change="handleTeachImages"
                      :on-success="teachImagesSuccess"
                      :headers="headers"
                      :before-upload="beforeUploadTeachImages"
                      :on-progress="handleProgress"
                      :limit="10"
                      :multiple=true
                      :file-list="teachImagesList">
                      <el-tooltip class="item" effect="light" content="不得超过30M" placement="top">
                        <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                      </el-tooltip>
                    </el-upload>
                  </Form-item>
                  <Form-item :label-width="100">
                    <li v-for="(item,index) in images">
                      <a @click="openImage(item)" v-show="item">查看</a>
                      <a @click="deleteImages('IMAGES',item)" v-show="item">删除</a>
                    </li>
                  </Form-item>
                </Row>
                <Row v-if="formData.account && canEdit">
                    <Form-item :label-width="100" label="登录账号:">
                      {{ formData.account }}
                    </Form-item>
                </Row>
                <Row>
                  <Form-item :label-width="100" label="备注：">
                    <Input v-model="formData.remark" type="textarea" :maxlength="200"
                           :autosize="{minRows: 1,maxRows: 10}"/>
                  </Form-item>
                </Row>
              </i-col>
            </Row>
            <hr style="border: 1px dotted #ddd">
            <Row>
              <i-col style="border-right: 1px dotted #ddd;">
                <Row span="12">
                  <Tag style="margin-left: 10px" color="yellow">紧急联系方式</Tag>
                </Row>
                <Row>
                  <i-col span="6">
                    <Form-item :label-width="80" label="邮箱：">
                      <Input v-model="formData.tchForm.email"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="77" label="紧急电话：">
                      <Input v-model="formData.tchForm.mobileSos"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="80" label="Whatsapp账号：">
                      <Input v-model="formData.tchForm.whatAccount"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="80" label="Facebook账号：">
                      <Input v-model="formData.tchForm.faceBook"/>
                    </Form-item>
                  </i-col>
                </Row>
              </i-col>
            </Row>
            <div style="margin-top: 10px">
              <Row span="24">
                <i-col span="12" style="border-right: 1px dotted #ddd;" v-if="canEdit">
                  <Row span="12">
                    <Tag style="margin-left: 10px" color="yellow">联系方式</Tag>
                  </Row>
                  <Row span="10">
                    <i-col span="8">
                      <Form-item :label-width="85" label="区号：" >
                        <phone-area-select :areaNumValue="formData.areaNum"
                                           @on-change="onAreaNumChange"></phone-area-select>
                      </Form-item>

                      <Form-item :label-width="85" label="Microsoft Teams ID：">
                        <Input v-model="formData.skype"/>
                      </Form-item>
                    </i-col>
                    <i-col span="12">
                      <Form-item :label-width="85" label="手机号码：">
                        <Input v-model="formData.mobile" :number="true" placeholder="手机号和邮箱至少填一个"/>
                      </Form-item>
                      <Form-item :label-width="85" label="email：">
                        <Input v-model="formData.email" placeholder="手机号和邮箱至少填一个"/>
                      </Form-item>
                      <Form-item :label-width="77" label="登录方式：" prop="loginBy" v-if="isAddTch">
                        <Select v-model="formData.loginBy" transfer>
                          <Option v-for="item in $constant.loginBy"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                  </Row>
                </i-col>
                <i-col span="12">
                  <Row span="12">
                    <Tag color="yellow">系统权限</Tag>
                  </Row>
                  <Row span="10">
                    <i-col span="8">
                      <Form-item :label-width="77" label="试听权限：" prop="isAudition">
                        <Select v-model="formData.isAudition" clearable transfer>
                          <Option v-for="item in $constant.yn"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                    <i-col span="8">
                      <Form-item :label-width="77" label="是否录屏：">
                        <Select v-model="formData.isRecordScreen" clearable transfer>
                          <Option v-for="item in $constant.yesNoNum"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                    <i-col span="8">
                      <Form-item :label-width="77" label="专属老师：">
                        <Select v-model="formData.serviceType" clearable transfer>
                          <Option v-for="item in $constant.serviceType"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                  </Row>
                  <Row span="10">
                    <i-col span="8">
                      <Form-item :label-width="77" label="临时约课权限：">
                        <Select v-model="formData.tempSchedule" clearable transfer>
                          <Option v-for="item in $constant.yesNoNum"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                    <i-col span="16">
                      <FormItem :label-width="80" label="无试听权限原因：">
                        <Input v-model="formData.invalidListenCause"></Input>
                        <a v-if="tchId" style="font-size: 12px;" @click="showInvalidListenCauseLog=true">历史</a>
                      </FormItem>
                    </i-col>
                  </Row>
                  <!--                <Row span="10">-->
                  <!--                  <i-col span="12">-->
                  <!--                    <FormItem :label-width="77" label="CPU分数：" prop="cpuScore">-->
                  <!--                      <Input v-model="formData.cpuScore" :number="true"></Input>-->
                  <!--                    </FormItem>-->
                  <!--                  </i-col>-->
                  <!--                  <i-col span="12">-->
                  <!--                    <FormItem :label-width="77" label="操作系统：">-->
                  <!--                      <Input v-model="formData.os"></Input>-->
                  <!--                    </FormItem>-->
                  <!--                  </i-col>-->
                  <!--                </Row>-->
                  <Row span="10">
                    <!--                  <i-col span="12">-->
                    <!--                    <FormItem :label-width="77" label="上传网速：" prop="upSpeed">-->
                    <!--                      <Input type="text" v-model="formData.upSpeed" :number="true" placeholder="0.00" clearable></Input>-->
                    <!--                    </FormItem>-->
                    <!--                  </i-col>-->
                    <!--                  <i-col span="12">-->
                    <!--                    <FormItem :label-width="77" label="下载网速：" prop="downSpeed">-->
                    <!--                      <Input type="text" v-model="formData.downSpeed" :number="true" placeholder="0.00" clearable></Input>-->
                    <!--                    </FormItem>-->
                    <!--                  </i-col>-->
                    <!--                  <i-col span="12">-->
                    <!--                    <FormItem :label-width="77" label="录屏建议：">-->
                    <!--                      <Input v-model="formData.screenCapAdvice"></Input>-->
                    <!--                    </FormItem>-->
                    <!--                  </i-col>-->
                  </Row>
                  <Row span="10">
                    <i-col span="12" v-if="this.tchId">
                      <Form-item :label-width="77" label="状态：" prop="status" >
                        <Select v-model.number="formData.status" transfer>
                          <Option v-for="item in $constant.teacherStatus"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                    <i-col span="12">
                      <Form-item :label-width="77" label="可绑定权限：" prop="isCanBound">
                        <Select v-model.number="formData.isCanBound" transfer>
                          <Option v-for="item in $constant.yesNoNum"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                    <i-col span="12">
                      <Form-item :label-width="77" label="是否standby：" prop="isStandby">
                        <Select v-model.number="formData.isStandby" transfer>
                          <Option v-for="item in $constant.yesNoNum"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                    <i-col span="12">
                      <Form-item :label-width="77" label="19:00-20:30不可用" prop="isStandby">
                        <Select v-model.number="formData.disable18" transfer>
                          <Option v-for="item in $constant.yesNoNum"
                                  :value="item.code" :key="item.code">{{ item.text }}
                          </Option>
                        </Select>
                      </Form-item>
                    </i-col>
                  </Row>
                </i-col>
              </Row>
            </div>
            <hr style="border: 1px dotted #ddd; margin-top: 20px;">
            <Row>
              <i-col style="border-right: 1px dotted #ddd;">
                <Row span="12">
                  <Tag style="margin-left: 10px" color="yellow">其他信息</Tag>
                </Row>
                <Row>
                   <i-col span="5">
                    <Form-item :label-width="100" label="所在城市：">
                      <Input v-model="formData.tchForm.townOrCity"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="100" label="当前居住地：">
                      <Input v-model="formData.address"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="100" label="毕业院校：">
                      <Input v-model="formData.school"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="100" label="大学专业：">
                      <Input v-model="formData.tchForm.major"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="100" label="毕业年份：">
                      <DatePicker type="year" placeholder="Select year" @on-change="onYearChange" :value="formData.tchForm.yearOfGraduation"></DatePicker>
                    </Form-item>
                  </i-col>
                   <i-col span="5">
                    <Form-item :label-width="100" label="上传速度：">
                      <Input v-model="formData.upSpeed" @on-blur="validateNumericField(formData, 'upSpeed')">
                        <span slot="append">Mbps</span>
                      </Input>
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="100" label="下载速度：">
                      <Input v-model="formData.downSpeed" @on-blur="validateNumericField(formData, 'downSpeed')">
                        <span slot="append">Mbps</span>
                      </Input>
                    </Form-item>
                  </i-col>
                </Row>
                <Row>
                  <i-col span="5">
                    <Form-item :label-width="100" label="备用网络：">
                      <Input v-model="formData.tchForm.backUpInternetSpeed" />
                    </Form-item>
                  </i-col>
                  <i-col span="5">
                    <Form-item :label-width="100" label="备用电源：">
                      <Input v-model="formData.tchForm.backUpPower"/>
                    </Form-item>
                  </i-col>
                  <i-col span="5" v-if="formData.editPermission">
                    <Form-item :label-width="100" label="网络供应商：">
                      <Input v-model="formData.tchForm.networkProviders"/>
                    </Form-item>
                  </i-col>
                </Row>
              </i-col>
            </Row>
            <hr style="border: 1px dotted #ddd; margin-top: 20px;">
            <Row>
              <i-col v-if="formData.editPermission">
                <Row span="12">
                  <Tag style="margin-left: 10px" color="yellow">课表登记</Tag>
                </Row>
                <span class="course-tip">时间表（北京时间）。点击单元格切换状态：√ 可用，? 不确定，× 不可用</span>
                <Row style="margin-top: 10px;">
                  <i-col span="24">
                    <div style="overflow-x: auto;">
                      <div class="course-table" role="grid" aria-label="老师工作时间表">
                        <div class="course-row course-header">
                          <div class="course-cell time-slot">时间</div>
                          <div v-for="day in courseDays" :key="day" class="course-cell">{{ day }}</div>
                        </div>
                        <div v-for="slot in courseSlots" :key="slot" class="course-row">
                          <div class="course-cell time-slot">{{ slot }}</div>
                          <div
                            v-for="(day, index) in courseDays"
                            :key="day + slot"
                            class="course-cell selectable"
                            :class="availabilityClass(index + 1, slot)"
                            @click="canEdit && toggleAvailability(index + 1, slot)"
                            :style="{cursor: canEdit ? 'pointer' : 'default'}"
                          >
                            {{ availabilitySymbol(index + 1, slot) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </i-col>
                </Row>
              </i-col>
            </Row>
          </Form>
          <div class="footer" v-if="canEdit">
            <Button type="default" size="large" class="cancel" @click="visible=false">取消</Button>
            <Button type="primary" size="large" :loading="insertLoading" @click="updateTchInfo">保存</Button>
          </div>
        </Tab-pane>
        <Tab-pane label="推荐官" v-if="referrerTabVisible && detailTabRules.referrer" name="推荐官">
          <div v-if="tabName === '推荐官'" class="referrer-tab">
            <Row :gutter="16" style="margin-bottom: 12px">
              <i-col :span="8">
                <b>老师ID：</b>{{ referrerDetail.referrerId }}
              </i-col>
              <i-col :span="8">
                <b>姓名：</b>{{ referrerDetail.referrerName }}
              </i-col>
            </Row>
            <Table
              :columns="referrerMonthlyColumns"
              :data="referrerMonthlyStats"
              :loading="referrerMonthlyLoading"
              size="small"
              border
            ></Table>
          </div>
        </Tab-pane>
        <Tab-pane label="色块表" v-if="!isAddTch && detailTabRules.colorBlock" name="色块表">
          <div class="color-block-container">
            <div class="search-wrapper" ref="searchWrapper">
              <div class="search" @keyup.enter="search">
                <Form :label-width="60" :show-message="false">
                  <Row>
                    <i-col>
                      <Form-item label="选择日期">
                        <Date-picker v-model="dateRange" format="yyyy-MM-dd" :clearable="false" type="daterange"
                                     placement="bottom-start" placeholder="选择日期" style="width: 220px"
                                     transfer
                                     @on-change="onColorDateChange"></Date-picker>
                      </Form-item>
                    </i-col>
                  </Row>
                  <Row>
                    <i-col>
                      <Checkbox-group v-model="types">
                        <span>显示：</span>
                        <i style="background: #00DEFF" class="color"></i>
                        <Checkbox label="opened">
                          <span>买断时间</span>
                        </Checkbox>
                        <i style="background: #1B5E20" class="color"></i>
                        <Checkbox label="shortTerm">
                          <span>短期固定时间</span>
                        </Checkbox>
                        <i style="background: #66CC33" class="color"></i>
                        <Checkbox label="free">
                          <span>临时开课时间</span>
                        </Checkbox>
                        <i style="background: #FF9900" class="color"></i>
                        <Checkbox label="schedule">
                          <span>常规课</span>
                        </Checkbox>
                        <i style="background: #FFCCFF" class="color"></i>
                        <Checkbox label="book">
                          <span>绑定时间</span>
                        </Checkbox>
                        <i style="background: #ffff00" class="color"></i>
                        <Checkbox label="test">
                          <span>试听课</span>
                        </Checkbox>
                        <i style="background: #FF6B6B" class="color"></i>
                        <Checkbox label="partner">
                          <span>陪练课</span>
                        </Checkbox>
                        <i style="background: #AEAEAE" class="color"></i>
                        <Checkbox label="leave">
                          <span>老师请假</span>
                        </Checkbox>
                      </Checkbox-group>
                    </i-col>
                  </Row>
                </Form>
              </div>
            </div>
            </div>

            <div class="table-container">
              <div v-for="(group, groupIndex) in groupedDataList" :key="groupIndex">
                <table class="table">
                  <timetable-header :columns="titles"></timetable-header>
                  <tbody>
                    <timetable-row v-for="item in group" :key="item.week" :row="item" :columns="titles" :types="types"/>
                  </tbody>
                </table>
              </div>
              <table v-if="!groupedDataList || groupedDataList.length === 0" class="table">
                <tr style="height: 40px; text-align: center">
                  <td colspan="30">无数据</td>
                </tr>
              </table>
            </div>
        </Tab-pane>
        <Tab-pane label="在绑学生" v-if="seeStuList && tchTrackFormData.tchId > 0 && detailTabRules.bindStu" name="在绑学生">
          <List ref="dataList" :tableColumns="titleStuList" listUrl="/tch/std-list" class="pay-list"
                :params="tchTrackFormData" :onLoading="onLoading" :reload="reloadStuList" :pageSize=100
                :sync-route="false"></List>
        </Tab-pane>
        <!--follow up-->
        <Tab-pane label="老师跟踪记录" v-if="seeTchTrack && detailTabRules.track" name="老师跟踪记录">
          <div v-if="tabName === '老师跟踪记录'">
          <Form ref="tchTrackRecordForm" class="form" :model="tchTrackFormData" :rules="tchTrackRule">
            <Row>
              <Row>
                <Tag style="margin:0 0 20px 20px" color="yellow">新增记录</Tag>
              </Row>
              <Row align="middle">
                <Col :span="12">
                  <Form-Item :label-width="80">
                    <span>老师：{{ tchTrackFormData.tchId + '-' + tchTrackFormData.tchName }}</span>
                    <span style="margin-left: 20px;">所属外管：{{ tchTrackFormData.studyAdviserName }}</span>
                  </Form-Item>
                </Col>
              </Row>
              <Row>
                <Col :span="8">
                  <Form-Item :label-width="130" label="类型：" prop="trackType">
                    <Select v-model="tchTrackFormData.trackType" transfer>
                      <Option v-for="item in $constant.tchTrackRecordType" :value="item.code" :key="item.code">
                        {{ item.text }}
                      </Option>
                    </Select>
                  </Form-Item>
                </Col>
              </Row>
              <Row align="middle">
                <Col :span="16">
                  <Form-Item :label-width="130" label="内容：" prop="content">
                    <div @paste="handleContentPaste">
                      <Input v-model="tchTrackFormData.content" type="textarea" :rows="4"/>
                    </div>
                  </Form-Item>
                </Col>
                <Col :span="8">
                  <Form-item label="上传附件" prop="pic">
                    <el-upload
                      class="upload-demo"
                      :action="$appConfig.baseUrl + '/upload/fileUpload'"
                      :on-change="handleTrackFileChange"
                      :on-success="trackFileSuccess"
                      :on-progress="handleProgress"
                      :headers="headers"
                      :before-upload="beforeUploadTrackFile"
                      :limit="5"
                      multiple
                      :file-list="defaultPicsList">
                      <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
                    </el-upload>
                  </Form-item>
                </Col>
              </Row>
              <Row>

              </Row>
              <Row align="middle">
                <Col :soan="12">
                  <Form-Item :label-width="130">
                    <Button type="primary" @click="saveTrackRecord" v-if="formData.editPermission">保存</Button>
                    <Button type="default" @click="resetTrackRecord">取消</Button>
                  </Form-Item>
                </Col>
              </Row>
            </Row>
          </Form>
          <Row>
            <Col :span="5">
              <Tag style="margin:0 0 20px 20px" color="yellow">跟踪记录</Tag>
            </Col>
            <Col :span="6">
              <Form>
                <Form-item label="类型：" :label-width="60">
                  <Select v-model.number="queryParam.trackType" transfer @on-change="search" clearable>
                    <Option v-for="item in $constant.tchTrackRecordType" :value="item.code" :key="item.code">
                      {{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </Form>
            </Col>
          </Row>
          <Row>
            <List ref="dataList" :key="'tch-track-' + (tchId || 0)" :tableColumns="title" :reload="reload" listUrl="/tchTrack/list"
                  :params="queryParam" :onLoading="onLoading2" :onSelection="onSelection" operator=""
                  :sync-route="false"></List>
          </Row>
          </div>
        </Tab-pane>
        <Tab-pane label="数据统计" v-if="!isAddTch && tchId && detailTabRules.stat" name="数据统计">
          <div class="stat-tab" v-if="tabName === '数据统计'">
            <div class="stat-toolbar">
              <RadioGroup v-model="statPeriodType" type="button" :disabled="statLoading" @on-change="onStatPeriodChange">
                <Radio label="day">日</Radio>
                <Radio label="week">周</Radio>
                <Radio label="month">月</Radio>
                <Radio label="year">年</Radio>
              </RadioGroup>
              <DatePicker
                :key="statPeriodType"
                :type="statDatePickerType"
                :format="statDatePickerFormat"
                :value="statDate"
                :clearable="false"
                :disabled="statLoading"
                transfer
                placeholder="选择日期"
                style="width: 160px;margin-left: 12px;"
                @on-change="onStatDateChange">
              </DatePicker>
              <span v-if="statPeriodType === 'week' && statWeekRangeText" class="stat-week-hint">{{ statWeekRangeText }}</span>
              <Button type="primary" :loading="statLoading" style="margin-left: 12px;" @click="loadPersonalStat">查询</Button>
              <Button :loading="statExportLoading" style="margin-left: 8px;" @click="exportPersonalStat">导出</Button>
            </div>
            <div class="stat-grid">
              <div class="stat-card is-clickable" v-for="item in statCards" :key="item.title" @click="openStatDetail(item)">
                <div class="stat-card-title">{{ item.title }}</div>
                <div class="stat-card-value">{{ item.value }}</div>
                <div class="stat-card-sub">{{ item.sub }}</div>
                <div class="stat-card-foot" v-if="item.foot">{{ item.foot }}</div>
              </div>
            </div>
            <div class="stat-foot">统计截至 {{ personalStat.asOfTime || '—' }}</div>
          </div>
        </Tab-pane>
        <Tab-pane label="开课Checklist" v-if="!isAddTch && tchId && detailTabRules.onboarding" name="开课Checklist">
          <div class="onboarding-tab" v-if="tabName === '开课Checklist'">
            <div v-if="onboardingLoading" style="text-align: center; padding: 30px 0">
              <Spin size="large"></Spin>
            </div>
            <div v-else>
              <div class="onboarding-head">
                <span class="onboarding-progress">总进度：{{ onboardingDoneCount }}/{{ onboardingTotalCount }}</span>
                <span v-if="onboardingVersionId" class="onboarding-version">版本 {{ onboardingVersionId }}</span>
              </div>
              <Table :columns="onboardingColumns" :data="onboardingRows" border stripe size="small"></Table>
            </div>
          </div>
        </Tab-pane>
        <Tab-pane label="老师评分及课堂展示" v-if="!isAddTch && tchId && detailTabRules.classFeedback" name="老师评分及课堂展示">
          <TeacherClassScore v-if="tabName === '老师评分及课堂展示'" :tchId="tchId"></TeacherClassScore>
        </Tab-pane>
      </Tabs>
      <div slot="footer" style="display: none;"></div>
    </Modal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
    <InvalidListenCauseLogModal v-model="showInvalidListenCauseLog" :tchId="tchId"></InvalidListenCauseLogModal>
    <Modal
      v-model="showStatDetailModal"
      :title="statDetailModalTitle"
      width="880"
      :mask-closable="true"
      transfer>
      <div v-if="statDetailSplit && !statDetailField">
        <p class="stat-week-hint" style="margin: 0 0 12px;">{{ statDetailSplitHint }}</p>
        <div class="stat-grid">
          <div class="stat-card is-clickable" @click="openStatDetailField('numerator')">
            <div class="stat-card-title">{{ statDetailLeftTitle }}</div>
            <div class="stat-card-value">{{ statDetailLeftValue }}</div>
            <div class="stat-card-sub">分子</div>
          </div>
          <div class="stat-card is-clickable" @click="openStatDetailField('denominator')">
            <div class="stat-card-title">{{ statDetailRightTitle }}</div>
            <div class="stat-card-value">{{ statDetailRightValue }}</div>
            <div class="stat-card-sub">分母</div>
          </div>
          <div class="stat-card is-clickable" v-if="statDetailHasDiff" @click="openStatDetailField('nonFullLessons')">
            <div class="stat-card-title">{{ statDetailDiffTitle }}</div>
            <div class="stat-card-value">{{ statDetailDiffValue }}</div>
            <div class="stat-card-sub">差值</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="statDetailSplit" style="margin-bottom: 8px;">
          <a href="javascript:;" @click.prevent="backStatDetailCards">返回卡片</a>
          <span class="stat-week-hint">{{ statDetailFieldTitle }}</span>
        </div>
        <p v-if="statDetailField === 'nonFullLessons'" class="stat-week-hint" style="margin: 0 0 12px;">
          该老师区间内未全勤课节。迟到写出秒数；请假区分提前请假、临时请假；早退、缺席分别写出。学生请假、管理员取消、学生缺席且老师未缺席的课不计入。
        </p>
        <Table :columns="statDetailColumns" :data="statDetailTableData" :loading="statDetailLoading" border stripe></Table>
        <div style="margin-top: 12px; text-align: right;">
          <Page
            :total="statDetailTotal"
            :current="statDetailPageIndex"
            :page-size="statDetailPageSize"
            show-total
            show-sizer
            @on-change="onStatDetailPageChange"
            @on-page-size-change="onStatDetailPageSizeChange">
          </Page>
        </div>
      </div>
      <div slot="footer">
        <Button :loading="statDetailExportLoading" :disabled="statDetailSplit && !statDetailField" @click="exportStatDetail">导出</Button>
        <Button v-if="statDetailSplit && statDetailField" @click="backStatDetailCards">返回</Button>
        <Button type="primary" @click="showStatDetailModal=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import SingleOnePicUpload from '../../common/SingleOnePicUpload.vue'
import commonUtils from '@/tools/commonUtils.js'
import dateFormat from '@/tools/date/format.js'
import dates from '@/tools/date/dates.js'
import TimetableHeader from '../../lesson/TimetableHeader.vue'
import TimetableRow from '../../lesson/TimetableRow.vue'
import multipleImageUpload from '../../common/multipleImageUpload.vue'
import Vue from 'vue'
import '../../../directive/drag-modal'
import ShowImageCarousel from '../../order/ShowImageCarousel.vue'
import TeacherClassScore from '../TeacherClassScore.vue'
import InvalidListenCauseLogModal from './InvalidListenCauseLogModal.vue'
import { renderTrackContentAttach } from '@/utils/trackContentAttach'
import Viewer from 'v-viewer'

Vue.use(Viewer)

export default {
  components: {
    SingleOnePicUpload, TimetableHeader, TimetableRow, multipleImageUpload, ShowImageCarousel, TeacherClassScore, InvalidListenCauseLogModal
  },
  name: 'TchInfoModal',
  dialLoading: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    tchId: {
      type: Number,
      default: null,
    },
    addType: {
      type: String,
      default: null,
    },
    recruitFlowEntry: {
      type: String,
      default: null,
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    showTchSelf: {
      type: Boolean,
      default: false
    },
    showStuList: {
      type: Boolean,
      default: false
    },
  },
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      showInvalidListenCauseLog: false,
      seeTchTrack: false,
      seeStuList: this.showStuList,
      saveType: this.addType,
      showImgModal: false,
      showImgList: [],
      dateRange: [],
      colorBlockReqKey: '',
      colorBlockSeq: 0,
      dataList: [],
      types: ['opened', 'shortTerm', 'free', 'schedule', 'book', 'test', 'leave', 'partner'],
      insertLoading: false,
      channelOptions: [],
      reload: 0,
      reloadStuList: 0,
      imageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      text: '编辑头像',
      totalImageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      featuresArray: [],
      levelArray: [],
      defaultPicsList: [],
      certificateTesolUrl: '',
      certificateTesolUrlList: [],
      certificateTesolOutUrl: '',
      certificateTesolOutUrlList: [],
      certificateTeflUrl: '',
      certificateTeflUrlList: [],
      certificateTeflOutUrl: '',
      certificateTeflOutUrlList: [],
      certificateTeylUrl: '',
      certificateTeylUrlList: [],
      certificateEnglishUrl: '',
      certificateEnglishUrlList: [],
      certificateEnglishOutUrl: '',
      certificateEnglishOutUrlList: [],
      introduceDocUrl: '',
      teachVideo: '',
      images: [],
      introduceDocUrlList: [],
      introduceVideoUrl: '',
      introduceVideoUrlList: [],
      nationalityImageUrl: '',
      nationalityImageUrlList: [],
      selfIntroductionVideo: '',
      selfIntroductionVideoList: [],
      teachVideoList: [],
      teachImagesList: [],
      polishLessonVideoList: [''],
      headers: {},
      resume: '',
      resumeList: [],
      tabName: '基本信息',
      detailTabSeq: 0,
      detailTabRules: {
        referrer: false,
        colorBlock: false,
        bindStu: false,
        track: false,
        stat: false,
        onboarding: false,
        classFeedback: false
      },
      referrerTabVisible: false,
      referrerDetail: {},
      referrerMonthlyStats: [],
      referrerMonthlyLoading: false,
      referrerMonthlyColumns: [
        { title: '月份', key: 'month', align: 'center' },
        { title: '推荐总数', key: 'recommendCount', align: 'center' },
        { title: '审核通过数', key: 'approveCount', align: 'center' },
        { title: '审核拒绝数', key: 'rejectCount', align: 'center' },
        { title: '开课数', key: 'openClassCount', align: 'center' }
      ],
      action: '',
      uploadText: '上传',
      formData: {
        editPermission: false,
        id: null,
        tchId: null,
        studyAdviserName: '',
        lastName: '',
        firstName: '',
        password: '',
        newPassword: '',
        sex: null,
        age: null,
        channel: 1,
        country: '',
        eduLevel: '',
        accent: null,
        category: this.addType === 'agency' ? 6 : 0,
        salary: '',
        tchType: '',
        timezone: '',
        timeDiff: '',
        certificateTesol: '',
        certificateTesolOut: '',
        certificateTefl: '',
        certificateTeflOut: '',
        certificateTeyl: '',
        certificateEnglish: '',
        certificateEnglishOut: '',
        experience: '',
        features: '',
        suitableLevel: '',
        introduceDoc: '',
        introduceVideo: '',
        polishLessonVideos: '',
        nationalityImage: '',
        sign: '',
        birthday: '',
        star: '',
        areaNum: '',
        account: '',
        mobile: '',
        loginBy: 2,
        skype: '',
        isAudition: 'n',
        status: 0,
        remark: '',
        isRecordScreen: 0,
        serviceType: 0,
        tempSchedule: 0,
        address: '',
        classin: '',
        selfIntroductionVideo: '',
        resume: '',
        itemUrl: '',
        imageUrl: '',
        email: '',
        isCanBound: 0,
        isStandby: 1,
        accentScore: '',
        cpuScore: '',
        upSpeed: '',
        downSpeed: '',
        screenCapAdvice: '',
        os: '',
        characteristic: '',
        startClassTime: '',
        invalidListenCause: '',
        fm: '',
        teachVideo: '',
        images: '',
        teachVideoList: '',
        disable18: 0,
        crtBeginTime: '',
        crtEndTime: '',
        tchForm: {
          mobile: '',
          email: '',
          mobileSos: '',
          whatAccount: '',
          faceBook: '',
          townOrCity: '',
          address: '',
          school: '',
          major: '',
          yearOfGraduation: '',
          upSpeed: '',
          downSpeed: '',
          backUpInternetSpeed: '',
          backUpPower: '',
          expectSalary: '',
          showSalary: false,
          networkProviders: '',
          regFrom: '',
        },
        workTimes: [],
      },
      title: [
        {
          title: '创建时间',
          width: 170,
          render: (h, params) => {
            let time = params.row.createTime
            return h('span', time && $moment(time, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '类型',
          width: 110,
          render: (h, params) => {
            let trackType = params.row.trackType
            let typeEnum = $constant.getEnum($constant.tchTrackRecordType, trackType)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '内容',
          render: (h, params) => {
            return renderTrackContentAttach(h, params.row.content, (urls, index) => this.viewFile(urls, index))
          }
        },
        {
          title: '附件',
          align: 'center',
          width: 180,
          render: (h, params) => {
            let row = params.row
            if (row.urls && row.urls.length > 0) {
              let nodes = []
              let imageUrls = row.urls.filter(url => /\.(jpg|jpeg|png|gif|bmp|webp)(\?|$)/i.test(url))
              row.urls.forEach((url, index) => {
                let isImage = /\.(jpg|jpeg|png|gif|bmp|webp)(\?|$)/i.test(url)
                let isOfficeDoc = /\.(doc|docx|xls|xlsx|ppt|pptx|odt|ods|odp)(\?|$)/i.test(url)
                if (isImage) {
                  let imgIndex = imageUrls.indexOf(url)
                  nodes.push(h('img', {
                    attrs: { src: url },
                    style: {
                      width: '48px',
                      height: '48px',
                      objectFit: 'cover',
                      marginRight: '4px',
                      borderRadius: '3px',
                      cursor: 'pointer',
                      verticalAlign: 'middle'
                    },
                    on: { click: () => this.viewFile(imageUrls, imgIndex) }
                  }))
                } else if (isOfficeDoc) {
                  nodes.push(h('a', {
                    style: { display: 'inline-block', marginRight: '4px' },
                    attrs: { href: 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url), target: '_blank' }
                  }, '预览'))
                } else {
                  nodes.push(h('a', {
                    style: { display: 'inline-block', marginRight: '4px' },
                    attrs: { href: url, target: '_blank' }
                  }, '下载'))
                }
              })
              return h('div', nodes)
            }
            return h('span', '')
          }
        },
        {
          title: '处理人',
          width: 110,
          key: 'creatorName',
        }
      ],
      titleStuList: [
        {
          title: '学生ID',
          width: 110,
          key: 'uid'
        },
        {
          title: '学生姓名',
          key: 'nickname',
          width: 110
        },
        {
          title: '销售',
          width: 110,
          key: 'adviserName',
        },
        {
          title: '学导',
          width: 110,
          key: 'studyAdviserName',
        },
        {
          title: '上课时间',
          width: 170,
          render: (h, params) => {
            let list = params.row.bookWorkLessonOpenedTimeList
            let spanArr = []
            if (list) {
              list.forEach(function (element) {
                let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                spanArr.push(h('span', '[' + $constant.weekZh[element.week] + startTime + ']'))
                spanArr.push(h('br'))
              })
            }
            return h('div', spanArr)
          }
        },
      ],
      visible: this.value,
      isAddTch: true,
      tchRule: {
        sex: [
          {type: 'number', required: true, message: '性别不能为空', trigger: 'blur'}
        ],
        status: [
          {type: 'number', required: true, message: '状态不能为空', trigger: 'blur'}
        ],
        category: [
          {type: 'number', required: true, message: '类型不能为空', trigger: 'blur'}
        ],
        tchType: [
          {type: 'number', required: true, message: '授课类型不能为空', trigger: 'blur'}
        ],
        isAudition: [
          {type: 'string', required: true, message: '试听权限不能为空', trigger: 'blur'}
        ]
      },
      tchTrackFormData: {
        trackType: null,
        content: '',
        tchId: null,
        tchName: '',
        studyAdviserName: '',
        createTime: null,
        picUrl: ''
      },
      queryParam: {
        trackType: null,
        tchId: ''
      },
      queryParams: {
        startTime: '',
        endTime: '',
        tchId: '',
        totalCount: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      tchTrackRule: {
        tchId: [{type: 'number', required: true, message: 'tchId不能为空', trigger: 'blur'}],
        trackType: [{type: 'number', required: true, message: '类型不能为空', trigger: 'blur'}],
        content: [{type: 'string', required: true, message: '内容不能为空', trigger: 'blur'}]
      },
      timeSlots: [
        { time: '6:00pm-6:30pm', startTime: '18:00', endTime: '18:30' },
        { time: '6:30pm-7:00pm', startTime: '18:30', endTime: '19:00' },
        { time: '7:00pm-7:30pm', startTime: '19:00', endTime: '19:30' },
        { time: '7:30pm-8:00pm', startTime: '19:30', endTime: '20:00' },
        { time: '8:00pm-8:30pm', startTime: '20:00', endTime: '20:30' },
        { time: '8:30pm-9:00pm', startTime: '20:30', endTime: '21:00' },
        { time: '9:00pm-9:30pm', startTime: '21:00', endTime: '21:30' }
      ],
      courseDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      courseSlots: ['6:00pm-6:30pm', '6:30pm-7:00pm', '7:00pm-7:30pm', '7:30pm-8:00pm', '8:00pm-8:30pm', '8:30pm-9:00pm', '9:00pm-9:30pm'],
      availabilityStates: ['available', 'unsure', 'unavailable', ''],
      availabilitySymbols: {
        available: '√',
        unsure: '?',
        unavailable: '×',
        '': '-'
      },
      workTimeSelections: {},
      statPeriodType: 'month',
      statDate: new Date(),
      statStartDate: '',
      statEndDate: '',
      statLoading: false,
      statExportLoading: false,
      personalStat: {
        leaveRate: '—',
        leaveNumerator: null,
        leaveDenominator: null,
        tempLeaveRate: '—',
        tempLeaveCount: null,
        tempLeaveBaseCount: null,
        fullAttendanceRate: '—',
        fullAttendanceCount: null,
        fullAttendanceTotalCount: null,
        lateRate: '—',
        lateCount: null,
        lateBaseCount: null,
        earlyRate: '—',
        earlyCount: null,
        earlyBaseCount: null,
        returnLessonHours: null,
        refundStudentCount: null,
        demoAttendDealRate: '—',
        demoAttendDealCount: null,
        demoAttendCount: null,
        attendLessonRate: '—',
        attendLessonCount: null,
        attendLessonBaseCount: null,
        asOfTime: ''
      },
      showStatDetailModal: false,
      statDetailMetric: '',
      statDetailField: '',
      statDetailSplit: false,
      statDetailLeftTitle: '',
      statDetailLeftValue: '—',
      statDetailRightTitle: '',
      statDetailRightValue: '—',
      statDetailHasDiff: false,
      statDetailDiffTitle: '未全勤课节',
      statDetailDiffValue: '—',
      statDetailFieldTitle: '',
      statDetailLoading: false,
      rankScoreSeq: 0,
      statDetailExportLoading: false,
      statDetailTableData: [],
      statDetailTotal: 0,
      statDetailPageIndex: 1,
      statDetailPageSize: 20,
      onboardingLoading: false,
      onboardingRows: [],
      onboardingDoneCount: 0,
      onboardingTotalCount: 0,
      onboardingVersionId: null,
      onboardingColumns: [
        {
          title: '阶段',
          key: 'stageName',
          width: 180
        },
        {
          title: '标题',
          key: 'title',
          minWidth: 200
        },
        {
          title: '是否完成',
          width: 90,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {color: params.row.done ? 'green' : 'default'}
            }, params.row.done ? '已完成' : '未完成')
          }
        },
        {
          title: '文字',
          minWidth: 160,
          render: (h, params) => {
            return h('span', params.row.textValue || '-')
          }
        },
        {
          title: '图片',
          width: 180,
          render: (h, params) => {
            return this.renderOnboardingPhotos(h, params.row.photoUrls)
          }
        }
      ]
    }
  },
  computed: {
    tabBarKey () {
      let rules = this.detailTabRules || {}
      return [
        this.isAddTch ? '1' : '0',
        this.tchId || 0,
        this.seeStuList ? '1' : '0',
        this.seeTchTrack ? '1' : '0',
        this.referrerTabVisible ? '1' : '0',
        rules.referrer ? '1' : '0',
        rules.colorBlock ? '1' : '0',
        rules.bindStu ? '1' : '0',
        rules.track ? '1' : '0',
        rules.stat ? '1' : '0',
        rules.onboarding ? '1' : '0',
        rules.classFeedback ? '1' : '0'
      ].join('-')
    },
    showBirthday () {
      let adminRule = this.$store.get('adminRule')
      // 仅 adminRule=0或3（顶级管理员/外管）时显示生日
      return adminRule === 0 || adminRule === 3 || adminRule === '0' || adminRule === '3'
    },
    enabledChannelOptions () {
      let list = (this.channelOptions || []).filter(item => item.status === 1)
      const current = this.formData.tchForm && this.formData.tchForm.regFrom
      if (current && !list.some(item => item.param === current)) {
        const extra = (this.channelOptions || []).find(item => item.param === current)
        if (extra) {
          list = list.concat([extra])
        }
      }
      return list
    },
    titles: function () {
      /*
      let teacher = {
        title: '老师',
        width: 100,
        key: 'tchId',
      }
      */
      let startHour = 23
      let endHour = 0
      this.dataList.forEach(item => {
        if (item.bookTchOpenedTimeDtoList) {
          item.bookTchOpenedTimeDtoList.forEach(i => {
            startHour = Math.min(Math.floor(i.startTime / 60 / 60), startHour)
            endHour = Math.max(Math.floor(i.endTime / 60 / 60), endHour)

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookTchOpenedTimeDtoList time error', item)
            }
          })
        }
        if (item.bookWorkLessonOpenedTimeDtoList) {
          item.bookWorkLessonOpenedTimeDtoList.forEach(i => {
            startHour = Math.min(Math.floor(i.startTime / 60 / 60), startHour)
            endHour = Math.max(Math.floor(i.endTime / 60 / 60), endHour)

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookWorkLessonOpenedTimeDtoList time error', item)
            }
          })
        }
        if (item.tchScheduleBookLessonOpenedDtoList) {
          item.tchScheduleBookLessonOpenedDtoList.forEach(i => {
            startHour = Math.min(Math.floor(new Date(i.lsnBeginTime * 1000).getHours()), startHour)
            endHour = Math.max(Math.floor(new Date(i.lsnEndTime * 1000).getHours()), endHour)

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('tchScheduleBookLessonOpenedDtoList time error', item)
            }
          })
        }
        if (item.tchScheduleBookLessonTestOpenedDtoList) {
          item.tchScheduleBookLessonTestOpenedDtoList.forEach(i => {
            startHour = Math.min(Math.floor(new Date(i.lsnBeginTime * 1000).getHours()), startHour)
            endHour = Math.max(Math.floor(new Date(i.lsnEndTime * 1000).getHours()), endHour)

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('tchScheduleBookLessonTestOpenedDtoList time error', item)
            }
          })
        }
        if (item.bookTchRandomOpenedTimeDtoList) {
          item.bookTchRandomOpenedTimeDtoList.forEach(i => {
            startHour = Math.min(Math.floor(new Date(i.startTime * 1000).getHours()), startHour)
            endHour = Math.max(Math.floor(new Date(i.endTime * 1000).getHours()), endHour)

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookTchRandomOpenedTimeDtoList time error', item)
            }
          })
        }
        if (item.bookTchLeaveTimeDtoList) {
          item.bookTchLeaveTimeDtoList.forEach(i => {
            if (new Date(item.dateStr).getDate() === new Date(i.startTime * 1000).getDate() &&
              new Date(item.dateStr).getDate() === new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(Math.floor(new Date(i.startTime * 1000).getHours()), startHour)
              endHour = Math.max(Math.floor(new Date(i.endTime * 1000 - 1).getHours()), endHour)
            } else if (new Date(item.dateStr).getDate() === new Date(i.startTime * 1000).getDate() &&
              new Date(item.dateStr).getDate() !== new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(Math.floor(new Date(i.startTime * 1000).getHours()), startHour)
              endHour = Math.max(23, endHour)
            } else if (new Date(item.dateStr).getDate() !== new Date(i.startTime * 1000).getDate() &&
              new Date(item.dateStr).getDate() === new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(9, startHour)
              endHour = Math.max(Math.floor(new Date(i.endTime * 1000 - 1).getHours()), endHour)
            } else if (new Date(item.dateStr).getDate() !== new Date(i.startTime * 1000).getDate() &&
              new Date(item.dateStr).getDate() !== new Date(i.endTime * 1000 - 1).getDate()) {
              startHour = Math.min(9, startHour)
              endHour = Math.max(23, endHour)
            }

            if (isNaN(startHour) || isNaN(endHour)) {
              console.log('bookTchLeaveTimeDtoList time error', item)
            }
          })
        }
      })
      let columns = [
        {
          title: '时间',
          width: 100,
          key: 'title',
        }]

      startHour = Math.max(9, startHour)
      for (let i = startHour; i <= endHour; i++) {
        columns.push({
          title: i,
          hour: i,
        })
      }
      return columns
    },
    // 按周分组数据
    groupedDataList () {
      console.log('groupedDataList 计算属性被调用')
      console.log('dataList:', this.dataList)

      if (!this.dataList || this.dataList.length === 0) {
        console.log('dataList 为空，返回 []')
        return []
      }

      const groups = []
      let currentGroup = []

      this.dataList.forEach((item, index) => {
        currentGroup.push(item)
        console.log(`添加第 ${index + 1} 天数据，week=${item.week}`)
        // 如果是周日（week === 7）或者是最后一天，结束当前组
        if (item.week === 7 || index === this.dataList.length - 1) {
          console.log(`结束当前组，共 ${currentGroup.length} 天`)
          groups.push(currentGroup)
          currentGroup = []
        }
      })

      console.log('最终分组结果:', groups)
      return groups
    },
    statWeekRangeText () {
      if (this.statPeriodType !== 'week' || !this.statStartDate || !this.statEndDate) {
        return ''
      }
      return this.statStartDate + ' ~ ' + this.statEndDate
    },
    statDatePickerType () {
      if (this.statPeriodType === 'year') {
        return 'year'
      }
      if (this.statPeriodType === 'month') {
        return 'month'
      }
      return 'date'
    },
    statDatePickerFormat () {
      if (this.statPeriodType === 'year') {
        return 'yyyy'
      }
      if (this.statPeriodType === 'month') {
        return 'yyyy-MM'
      }
      return 'yyyy-MM-dd'
    },
    statLeaveRateText () {
      if (this.personalStat.leaveDenominator === 0) {
        return '—'
      }
      return this.personalStat.leaveRate || '—'
    },
    statLeaveSub () {
      let n = this.personalStat.leaveNumerator
      let d = this.personalStat.leaveDenominator
      if (n == null || d == null || d === 0) {
        return '—'
      }
      return n + ' / ' + d + ' 节'
    },
    statTempLeaveRateText () {
      if (this.personalStat.tempLeaveBaseCount === 0) {
        return '—'
      }
      return this.personalStat.tempLeaveRate || '—'
    },
    statTempLeaveSub () {
      let n = this.personalStat.tempLeaveCount
      let d = this.personalStat.tempLeaveBaseCount
      if (n == null || d == null || d === 0) {
        return '—'
      }
      return n + ' / ' + d
    },
    statFullAttendRateText () {
      if (this.personalStat.fullAttendanceTotalCount === 0) {
        return '—'
      }
      return this.personalStat.fullAttendanceRate || '—'
    },
    statFullAttendSub () {
      let n = this.personalStat.fullAttendanceCount
      let d = this.personalStat.fullAttendanceTotalCount
      if (n == null || d == null || d === 0) {
        return '—'
      }
      return n + ' / ' + d + ' 节'
    },
    statFullAttendDiffText () {
      let n = this.personalStat.fullAttendanceCount
      let d = this.personalStat.fullAttendanceTotalCount
      if (n == null || d == null) {
        return '—'
      }
      return String(Math.max(d - n, 0))
    },
    statLateRateText () {
      if (this.personalStat.lateBaseCount === 0) {
        return '—'
      }
      return this.personalStat.lateRate || '—'
    },
    statLateSub () {
      let n = this.personalStat.lateCount
      let d = this.personalStat.lateBaseCount
      if (n == null || d == null || d === 0) {
        return '—'
      }
      return n + ' / ' + d + ' 节'
    },
    statEarlyRateText () {
      if (this.personalStat.earlyBaseCount === 0) {
        return '—'
      }
      return this.personalStat.earlyRate || '—'
    },
    statEarlySub () {
      let n = this.personalStat.earlyCount
      let d = this.personalStat.earlyBaseCount
      if (n == null || d == null || d === 0) {
        return '—'
      }
      return n + ' / ' + d + ' 节'
    },
    statReturnHoursText () {
      return this.personalStat.returnLessonHours == null ? '0' : String(this.personalStat.returnLessonHours)
    },
    statReturnHoursSub () {
      return '课堂投诉审核通过、外教课、赠课原因是老师'
    },
    statRefundText () {
      return this.personalStat.refundStudentCount == null ? '—' : String(this.personalStat.refundStudentCount)
    },
    statRefundSub () {
      if (this.personalStat.refundStudentCount == null) {
        return '人'
      }
      return this.personalStat.refundStudentCount + ' 人'
    },
    statDemoRateText () {
      return this.personalStat.demoAttendDealRate || '—'
    },
    statDemoSub () {
      let n = this.personalStat.demoAttendDealCount
      let d = this.personalStat.demoAttendCount
      if (n == null || d == null) {
        return '—'
      }
      return n + ' / ' + d
    },
    statAttendRateText () {
      return this.personalStat.attendLessonRate || '—'
    },
    statAttendSub () {
      let n = this.personalStat.attendLessonCount
      let d = this.personalStat.attendLessonBaseCount
      if (n == null || d == null) {
        return '—'
      }
      return n + ' / ' + d
    },
    statDetailSplitHint () {
      if (this.statDetailHasDiff) {
        return '跟看板详情同一口径，点分子、分母或未全勤课节看明细。'
      }
      return '跟看板详情同一口径，点分子或分母看明细。'
    },
    statDetailModalTitle () {
      let names = {
        leaveRate: '请假率',
        tempLeaveRate: '临时请假率',
        fullAttendanceRate: '全勤率',
        lateRate: '迟到率',
        earlyRate: '早退率',
        attendLessonRate: '上课率',
        returnLessonHours: '返课时数',
        refundStudentCount: '退费学生数',
        demoAttendDealRate: 'Demo出席成交率'
      }
      let name = names[this.statDetailMetric] || '数据统计'
      if (this.statStartDate && this.statEndDate) {
        return name + ' · ' + this.statStartDate + ' ~ ' + this.statEndDate
      }
      return name
    },
    statDetailColumns () {
      const $constant = this.$constant
      if (this.statDetailField === 'nonFullLessons') {
        return [
          {
            title: '老师',
            key: 'teacher',
            align: 'center',
            minWidth: 220,
            render: (h, params) => {
              const row = params.row || {}
              return renderTchNameWithScore(h, {
              text: this.statTeacherLabel(row),
              score: row.monthRankScore
            })
            }
          },
          {title: '课节ID', key: 'lessonId', align: 'center', minWidth: 110},
          {title: '上课时间', key: 'occurTime', align: 'center', minWidth: 170},
          {title: '异常原因', key: 'extra', align: 'center', minWidth: 220}
        ]
      }
      if (this.statDetailMetric === 'returnLessonHours') {
        return [
          {title: '学生ID', key: 'uid', align: 'center', minWidth: 90},
          {title: '学生姓名', key: 'studentName', align: 'center', minWidth: 120},
          {title: '老师ID', key: 'tchId', align: 'center', minWidth: 90},
          {title: '课时', key: 'num', align: 'center', minWidth: 80},
          {title: '类型', key: 'extra', align: 'center', minWidth: 90},
          {title: '审核时间', key: 'occurTime', align: 'center', minWidth: 160}
        ]
      }
      if (this.statDetailMetric === 'refundStudentCount') {
        return [
          {title: '学生ID', key: 'uid', align: 'center', minWidth: 90},
          {title: '学生姓名', key: 'studentName', align: 'center', minWidth: 120},
          {
            title: '最后一节课老师',
            key: 'lastTchName',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              const row = params.row || {}
              return renderTchNameWithScore(h, {
                text: (row.lastTchName || '').trim(),
                score: row.monthRankScore
              })
            }
          },
          {title: '对应老师外管', key: 'tchAdviserName', align: 'center', minWidth: 140},
          {
            title: '退费原因分类',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              let statusEnum = $constant.getEnum($constant.refundReasonCategory, params.row.refundReasonCategory)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {title: '退费原因', key: 'refundReason', align: 'center', minWidth: 180},
          {title: '类型', key: 'extra', align: 'center', minWidth: 90},
          {title: '时间', key: 'occurTime', align: 'center', minWidth: 160}
        ]
      }
      if (this.statDetailMetric === 'demoAttendDealRate') {
        return [
          {title: '学生ID', key: 'uid', align: 'center', minWidth: 90},
          {title: '学生姓名', key: 'studentName', align: 'center', minWidth: 140},
          {title: '成交外教', key: 'demoTch', align: 'center', minWidth: 140},
          {title: '类型', key: 'extra', align: 'center', minWidth: 90},
          {title: '时间', key: 'occurTime', align: 'center', minWidth: 160}
        ]
      }
      if (this.statDetailMetric === 'leaveRate' || this.statDetailMetric === 'fullAttendanceRate' || this.statDetailMetric === 'lateRate' || this.statDetailMetric === 'earlyRate') {
        return [
          {title: '课节ID', key: 'lessonId', align: 'center', minWidth: 110},
          {title: '老师ID', key: 'tchId', align: 'center', minWidth: 90},
          {title: '学生ID', key: 'uid', align: 'center', minWidth: 90},
          {title: '上课时间', key: 'occurTime', align: 'center', minWidth: 170},
          {title: '类型', key: 'extra', align: 'center', minWidth: 140}
        ]
      }
      if (this.statDetailMetric === 'attendLessonRate' || this.statDetailMetric === 'tempLeaveRate') {
        const self = this
        return [
          {title: '老师ID', key: 'tchId', align: 'center', minWidth: 90},
          {
            title: '姓名',
            key: 'tchName',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: self.formatStatFirstLastName(row),
                score: row.monthRankScore
              })
            }
          },
          {title: '学生ID', key: 'uid', align: 'center', minWidth: 90},
          {title: '课节数', key: 'num', align: 'center', minWidth: 80},
          {title: '类型', key: 'extra', align: 'center', minWidth: 160},
          {title: '时间', key: 'occurTime', align: 'center', minWidth: 160}
        ]
      }
      return [
        {title: '老师ID', key: 'tchId', align: 'center', minWidth: 90},
        {title: '账号', key: 'account', align: 'center', minWidth: 140},
        {
          title: '姓名',
          key: 'tchName',
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchName || ((row.firstName || '') + ' ' + (row.lastName || '')).trim(),
              score: row.monthRankScore
            })
          }
        },
        {title: '学生ID', key: 'uid', align: 'center', minWidth: 90},
        {title: '课节数', key: 'num', align: 'center', minWidth: 80},
        {title: '类型', key: 'extra', align: 'center', minWidth: 160},
        {title: '时间', key: 'occurTime', align: 'center', minWidth: 160}
      ]
    },
    statCards () {
      return [
        {
          title: '请假率',
          metric: 'leaveRate',
          split: true,
          value: this.statLeaveRateText,
          sub: this.statLeaveSub,
          leftTitle: '全部请假类型或老师缺席',
          leftValue: this.personalStat.leaveNumerator == null ? '—' : String(this.personalStat.leaveNumerator),
          rightTitle: '有课课节',
          rightValue: this.personalStat.leaveDenominator == null ? '—' : String(this.personalStat.leaveDenominator)
        },
        {
          title: '临时请假率',
          metric: 'tempLeaveRate',
          split: true,
          value: this.statTempLeaveRateText,
          sub: this.statTempLeaveSub,
          leftTitle: '临时请假+失联+取消课或老师缺席',
          leftValue: this.personalStat.tempLeaveCount == null ? '—' : String(this.personalStat.tempLeaveCount),
          rightTitle: '有课课节',
          rightValue: this.personalStat.tempLeaveBaseCount == null ? '—' : String(this.personalStat.tempLeaveBaseCount)
        },
        {
          title: '全勤率',
          metric: 'fullAttendanceRate',
          split: true,
          value: this.statFullAttendRateText,
          sub: this.statFullAttendSub,
          leftTitle: '全勤课节',
          leftValue: this.personalStat.fullAttendanceCount == null ? '—' : String(this.personalStat.fullAttendanceCount),
          rightTitle: '有课课节',
          rightValue: this.personalStat.fullAttendanceTotalCount == null ? '—' : String(this.personalStat.fullAttendanceTotalCount)
        },
        {
          title: '迟到率',
          metric: 'lateRate',
          split: true,
          value: this.statLateRateText,
          sub: this.statLateSub,
          foot: '迟到率 = 老师迟到的课 ÷ 正常上课的课。正常上课是已经上完，学生没有缺席，老师也没有缺席。没有通话记录按都没缺席、老师也没迟到/早退来算。没有正常上课课节显示 —。',
          leftTitle: '迟到课节',
          leftValue: this.personalStat.lateCount == null ? '—' : String(this.personalStat.lateCount),
          rightTitle: '正常上课课节',
          rightValue: this.personalStat.lateBaseCount == null ? '—' : String(this.personalStat.lateBaseCount)
        },
        {
          title: '早退率',
          metric: 'earlyRate',
          split: true,
          value: this.statEarlyRateText,
          sub: this.statEarlySub,
          foot: '早退率 = 老师早退的课 ÷ 正常上课的课。正常上课是已经上完，学生没有缺席，老师也没有缺席。没有通话记录按都没缺席、老师也没迟到/早退来算。没有正常上课课节显示 —。',
          leftTitle: '早退课节',
          leftValue: this.personalStat.earlyCount == null ? '—' : String(this.personalStat.earlyCount),
          rightTitle: '正常上课课节',
          rightValue: this.personalStat.earlyBaseCount == null ? '—' : String(this.personalStat.earlyBaseCount)
        },
        {
          title: '上课率',
          metric: 'attendLessonRate',
          split: true,
          value: this.statAttendRateText,
          sub: this.statAttendSub,
          leftTitle: '已上课课节',
          leftValue: this.personalStat.attendLessonCount == null ? '—' : String(this.personalStat.attendLessonCount),
          rightTitle: '买断+临时课节',
          rightValue: this.personalStat.attendLessonBaseCount == null ? '—' : String(this.personalStat.attendLessonBaseCount)
        },
        {
          title: '返课时数',
          metric: 'returnLessonHours',
          split: false,
          value: this.statReturnHoursText,
          sub: this.statReturnHoursSub
        },
        {
          title: '退费学生数',
          metric: 'refundStudentCount',
          split: false,
          value: this.statRefundText,
          sub: this.statRefundSub
        },
        {
          title: 'Demo出席成交率',
          metric: 'demoAttendDealRate',
          split: true,
          value: this.statDemoRateText,
          sub: this.statDemoSub,
          leftTitle: '成交学生',
          leftValue: this.personalStat.demoAttendDealCount == null ? '—' : String(this.personalStat.demoAttendDealCount),
          rightTitle: '出席学生',
          rightValue: this.personalStat.demoAttendCount == null ? '—' : String(this.personalStat.demoAttendCount)
        }
      ]
    }
  },
  created: function () {
    this.loadRegChannels()
    this.isAddTch = !(this.tchId > 0)
    if (this.addType === 'agency' && this.isAddTch) {
      this.saveType = 'agency'
      this.formData.category = 6
    }
    if (this.value) {
      this.loadDetailTabRules()
    }
  },
  mounted () {
    // sticky CSS 会自动处理，不需要额外监听
  },
  beforeDestroy () {
    // sticky CSS 会自动处理，不需要清理
  },
  methods: {
    loadMonthRankScores () {
      const table = this.statDetailTableData
      if (!table || !table.length) {
        return
      }
      // support both array and page payload
      const rows = Array.isArray(table) ? table : (table.data || [])
      const ids = rows.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'tchId', 'monthRankScore', map)
      })
    },

    loadDetailTabRules () {
      let self = this
      let rules = [
        {url: '/tch/detail/referrer', key: 'referrer'},
        {url: '/tch/detail/colorBlock', key: 'colorBlock'},
        {url: '/tch/detail/bindStu', key: 'bindStu'},
        {url: '/tch/detail/track', key: 'track'},
        {url: '/tch/detail/stat', key: 'stat'},
        {url: '/tch/detail/onboarding', key: 'onboarding'},
        {url: '/tch/detail/classFeedback', key: 'classFeedback'}
      ]
      let next = {
        referrer: false,
        colorBlock: false,
        bindStu: false,
        track: false,
        stat: false,
        onboarding: false,
        classFeedback: false
      }
      let seq = ++this.detailTabSeq
      this.detailTabRules = {
        referrer: false,
        colorBlock: false,
        bindStu: false,
        track: false,
        stat: false,
        onboarding: false,
        classFeedback: false
      }
      let pending = rules.length
      rules.forEach(function (rule) {
        self.$http.post('/common/getPermissionByUrl', {url: rule.url}).then(function (res) {
          next[rule.key] = !!(res && res.data === true)
        }).catch(function () {
          next[rule.key] = true
        }).finally(function () {
          pending -= 1
          if (pending === 0 && seq === self.detailTabSeq) {
            self.detailTabRules = next
            self.ensureDetailTabVisible()
          }
        })
      })
    },
    ensureDetailTabVisible () {
      let allowed = {
        '基本信息': true,
        '推荐官': this.referrerTabVisible && this.detailTabRules.referrer,
        '色块表': !this.isAddTch && this.detailTabRules.colorBlock,
        '在绑学生': this.seeStuList && this.tchTrackFormData.tchId > 0 && this.detailTabRules.bindStu,
        '老师跟踪记录': this.seeTchTrack && this.detailTabRules.track,
        '数据统计': !this.isAddTch && this.tchId && this.detailTabRules.stat,
        '开课Checklist': !this.isAddTch && this.tchId && this.detailTabRules.onboarding,
        '老师评分及课堂展示': !this.isAddTch && this.tchId && this.detailTabRules.classFeedback
      }
      if (!allowed[this.tabName]) {
        this.tabName = '基本信息'
      }
    },
    loadRegChannels () {
      let self = this
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data
        }
      })
    },
    onYearChange (val) {
      this.formData.tchForm.yearOfGraduation = val
    },
    onAgeChange (val) {
      if (this._syncingAgeBirthday) return
      if (!val) return
      this._syncingAgeBirthday = true
      const now = new Date()
      const year = now.getFullYear() - val
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      this.formData.birthday = `${year}-${month}-${day}`
      this.$nextTick(() => { this._syncingAgeBirthday = false })
    },
    onBirthdayChange () {
      if (this._syncingAgeBirthday) return
      const val = this.formData.birthday
      if (!val) return
      this._syncingAgeBirthday = true
      const birth = new Date(val)
      if (isNaN(birth.getTime())) {
        this._syncingAgeBirthday = false
        return
      }
      const now = new Date()
      let age = now.getFullYear() - birth.getFullYear()
      const m = now.getMonth() - birth.getMonth()
      if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
        age--
      }
      this.formData.age = age
      this.$nextTick(() => { this._syncingAgeBirthday = false })
    },
    validateNumericField (obj, key) {
      const value = obj[key]
      if (value === '' || value === null || value === undefined) return
      let strValue = String(value)
      const trimmed = strValue.trim()
      if (trimmed !== strValue) {
        obj[key] = trimmed
        strValue = trimmed
      }
      if (strValue === '') return
      if (/[^\d.]/.test(strValue) || (strValue.match(/\./g) || []).length > 1) {
        this.$Message.warning('请输入数字类型')
      }
    },
    // 获取指定星期和时间段的工作状态
    getWorkTimeStatus (week, startTime, endTime) {
      if (!this.formData.workTimes || this.formData.workTimes.length === 0) {
        return null
      }
      const workTime = this.formData.workTimes.find(wt =>
        wt.week === week && wt.startTime === startTime && wt.endTime === endTime
      )
      return workTime ? workTime.status : null
    },
    // 切换时间段的可用性状态
    toggleAvailability (week, slot) {
      const key = `${week}-${slot}`
      const current = this.workTimeSelections[key] || ''
      const currentIndex = this.availabilityStates.indexOf(current)
      const nextIndex = (currentIndex + 1) % this.availabilityStates.length
      const nextState = this.availabilityStates[nextIndex]

      if (nextState === '') {
        this.$delete(this.workTimeSelections, key)
      } else {
        this.$set(this.workTimeSelections, key, nextState)
      }
      this.syncWorkTimes()
    },
    // 获取时间段的可用性符号
    availabilitySymbol (week, slot) {
      const key = `${week}-${slot}`
      const state = this.workTimeSelections[key] || ''
      return this.availabilitySymbols[state]
    },
    // 获取时间段的样式类
    availabilityClass (week, slot) {
      const key = `${week}-${slot}`
      const state = this.workTimeSelections[key] || ''
      return state ? `state-${state}` : 'state-empty'
    },
    // 同步工作时间到formData
    syncWorkTimes () {
      this.formData.workTimes = Object.keys(this.workTimeSelections).map(key => {
        let [week, ...timeParts] = key.split('-')
        const slot = timeParts.join('-')

        // 解析时间段
        let [startTime, endTime] = slot.split('-')

        // 转换时间格式 (6:00pm -> 18:00)
        const convertTime = (timeStr) => {
          let isPM = timeStr.includes('pm')
          let cleanTime = timeStr.replace('pm', '').replace('am', '')
          let [hour, minute] = cleanTime.split(':')
          let hourNum = parseInt(hour)

          if (isPM && hourNum !== 12) {
            hourNum += 12
          } else if (!isPM && hourNum === 12) {
            hourNum = 0
          }

          return `${hourNum.toString().padStart(2, '0')}:${minute}`
        }

        const convertedStartTime = convertTime(startTime)
        const convertedEndTime = convertTime(endTime)

        return {
          week: parseInt(week),
          timeSlot: `${convertedStartTime}-${convertedEndTime}`,
          status: this.workTimeSelections[key],
          startTime: convertedStartTime,
          endTime: convertedEndTime
        }
      })
    },
    closeImgModal () {
      this.showImgList = []
      this.showImgModal = false
    },
    viewPic (row) {
      this.showImgList = row.urls
      this.showImgModal = true
    },
    viewFile (urls, index) {
      this.showImgList = urls
      this.showImgModal = true
    },
    redirectToTchSystem () {
      let self = this
      this.$http.get('/tch/getAdminToken?type=teacher').then(res => {
        if (res.data) {
          if (this.$appConfig.active === 'prod') {
            window.open('https://tutor.kouyujie.cn/#/login?mobile=' + self.formData.account + '&token=' + res.data + '&type=admin')
          } else {
            window.open('https://test.tutor.kouyujie.cn/#/login?mobile=' + self.formData.account + '&token=' + res.data + '&type=admin')
          }
        }
      })
      return
    },
    handleResume (file, fileList) {
      this.resumeList = fileList.slice(-1)
    },
    resumeSuccess (res, file, fileList) {
      this.formData.resume = res.data.name
      this.resume = res.data.url
    },
    handleSelfIntroductionVideo (file, fileList) {
      this.selfIntroductionVideoList = fileList.slice(-1)
    },
    handleTeachVideo (file, fileList) {
      this.teachVideoList = fileList.slice(-1)
    },
    handleTeachImages (file, fileList) {
      this.teachImagesList = fileList
    },
    addPolishLessonVideoRow () {
      if (this.polishLessonVideoList.length < 10) {
        this.polishLessonVideoList.push('')
      }
    },
    fillPolishLessonVideoList (raw) {
      const rows = []
      if (raw) {
        raw.split(',').forEach(function (url) {
          const trimmed = (url || '').trim()
          if (trimmed) {
            rows.push(commonUtils.getTotalUrl(trimmed) || trimmed)
          }
        })
      }
      this.polishLessonVideoList = rows.length ? rows : ['']
    },
    handleNationalityImageChange (file, fileList) {
      this.nationalityImageUrlList = fileList.slice(-1)
    },
    nationalityImageSuccess (res, file, fileList) {
      this.formData.tchForm.nationalityImage = res.data.name
      this.nationalityImageUrl = res.data.url
    },
    nationalityImageRemove (file, fileList) {
      if (!fileList || fileList.length === 0) {
        this.formData.tchForm.nationalityImage = ''
        this.nationalityImageUrl = ''
      }
    },
    beforeUploadNationalityImage (file) {
      const isImage = file.type.startsWith('image/')
      const isLt30M = file.size / 1024 / 1024 < 30

      if (!isImage) {
        this.$Message.error('只能上传图片文件!')
      }
      if (!isLt30M) {
        this.$Message.error('图片大小不能超过30MB!')
      }

      return isImage && isLt30M
    },
    selfIntroductionVideoSuccess (res, file, fileList) {
      this.formData.selfIntroductionVideo = res.data.name
      this.selfIntroductionVideo = res.data.url
    },
    teachVideoSuccess (res, file, fileList) {
      this.formData.teachVideo = res.data.name
      this.teachVideo = res.data.url
    },
    teachImagesSuccess (res, file, fileList) {
      this.images.push(res.data.url)
    },
    onAreaNumChange (val) {
      if (val) {
        this.formData.areaNum = val
      }
    },
    onTimeZoneChange (val) {
      if (val) {
//          this.formData.timezone = val
        this.formData.timeDiff = val
      }
    },
    openImage (url) {
      if (url) {
        window.open(url)
      }
    },
    updateTchInfo () {
      let self = this
      if (self.formData.account === '无查看权限') {
        self.$Message.warning('无修改权限!')
        return
      }

      // 数字类型字段校验
      const numericFields = [
        { obj: self.formData, key: 'salary', label: '时薪' },
        { obj: self.formData.tchForm, key: 'expectSalary', label: '期望时薪' },
        { obj: self.formData, key: 'upSpeed', label: '上传速度' },
        { obj: self.formData, key: 'downSpeed', label: '下载速度' }
      ]
      for (const field of numericFields) {
        const val = field.obj[field.key]
        if (val !== '' && val !== null && val !== undefined) {
          const trimmed = String(val).trim()
          if (trimmed !== '' && (/[^\d.]/.test(trimmed) || (trimmed.match(/\./g) || []).length > 1)) {
            self.$Message.warning(field.label + '：请输入数字类型')
            return
          }
        }
      }

      self.$refs.tchForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        // insert 操作时，firstName、lastName 和 fullName 至少有一个不能为空
        if (!this.tchId) {
          const firstName = self.formData.firstName || ''
          const lastName = self.formData.lastName || ''
          const fullName = (self.formData.tchForm && self.formData.tchForm.fullName) || ''
          if (!firstName.trim() && !lastName.trim() && !fullName.trim()) {
            self.$Message.warning('First Name、Last Name 和 Full Name 至少填写一个!')
            return
          }
        }
        if (self.featuresArray) {
          self.formData.features = self.featuresArray.join(',')
        }
        if (self.levelArray) {
          self.formData.suitableLevel = self.levelArray.join(',')
        }
        if (self.images) {
          self.formData.images = self.images.join(',')
        }
        var polishUrls = []
        var polishRows = self.polishLessonVideoList || []
        polishRows.forEach(function (url) {
          var trimmed = (url || '').trim()
          if (trimmed) {
            polishUrls.push(trimmed)
          }
        })
        self.formData.polishLessonVideos = polishUrls.join(',')
        var url
        if (this.tchId) {
          url = '/tch/bopsUpdate'
        } else {
          url = '/tch/bopsInsert'
          if (this.saveType === 'training') {
            self.formData.category = 4
          }
          if (this.saveType === 'agency') {
            self.formData.category = 6
          }
          if (this.recruitFlowEntry) {
            self.formData.recruitFlowEntry = this.recruitFlowEntry
          } else if (this.saveType === 'training') {
            self.formData.recruitFlowEntry = '培训中老师'
          } else if (this.saveType === 'agency') {
            self.formData.recruitFlowEntry = '中介'
          }
        }
        self.insertLoading = true
        self.$http.post(url, self.formData, {
          headers: {'Content-Type': 'application/json;charset=utf-8'},
          transformRequest: [function (data) {
            return JSON.stringify(data)
          }]
        }).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback()
            self.visible = false
            self.$Message.success('提交成功!')
          }
          self.insertLoading = false
        }).catch(function (e) {
          self.insertLoading = false
        })
      })
    },
    onLoading (loading) {
      this.insertLoading = loading
    },
    handleResult (file) {
      this.formData.avatar = file.name
      this.totalImageUrl = file.url
    },
    handleTESOL (file, fileList) {
      this.certificateTesolUrlList = fileList.slice(-1)
    },
    TESOLSuccess (res, file, fileList) {
      this.formData.certificateTesol = res.data.name
      this.certificateTesolUrl = res.data.url
    },
    handleTESOLOut (file, fileList) {
      this.certificateTesolOutUrlList = fileList.slice(-1)
    },
    TESOLOutSuccess (res, file, fileList) {
      this.formData.certificateTesolOut = res.data.name
      this.certificateTesolOutUrl = res.data.url
    },
    handleTEFL (file, fileList) {
      this.certificateTeflUrlList = fileList.slice(-1)
    },
    TEFLSuccess (res, file, fileList) {
      this.formData.certificateTefl = res.data.name
      this.certificateTeflUrl = res.data.url
    },
    handleTEFLOut (file, fileList) {
      this.certificateTeflOutUrlList = fileList.slice(-1)
    },
    TEFLOutSuccess (res, file, fileList) {
      this.formData.certificateTeflOut = res.data.name
      this.certificateTeflOutUrl = res.data.url
    },
    handleTEYL (file, fileList) {
      this.certificateTeylUrlList = fileList.slice(-1)
    },
    TEYLSuccess (res, file, fileList) {
      this.formData.certificateTeyl = res.data.name
      this.certificateTeylUrl = res.data.url
    },
    handleEnglish (file, fileList) {
      this.certificateEnglishUrlList = fileList.slice(-1)
    },
    handleEnglishOut (file, fileList) {
      this.certificateEnglishOutUrlList = fileList.slice(-1)
    },
    EnglishSuccess (res, file, fileList) {
      this.formData.certificateEnglish = res.data.name
      this.certificateEnglishUrl = res.data.url
    },
    EnglishOutSuccess (res, file, fileList) {
      this.formData.certificateEnglishOut = res.data.name
      this.certificateEnglishOutUrl = res.data.url
    },
    handleIntroduceDoc (file, fileList) {
      this.introduceDocUrlList = fileList.slice(-1)
    },
    IntroduceDocSuccess (res, file, fileList) {
      this.formData.introduceDoc = res.data.name
      this.introduceDocUrl = res.data.url
    },
    handleIntroduceVideoUrl (file, fileList) {
      this.introduceVideoUrlList = fileList.slice(-1)
    },
    IntroduceVideoUrlSuccess (res, file, fileList) {
      this.formData.introduceVideo = res.data.name
      this.introduceVideoUrl = res.data.url
    },
    openDetailLink () {
      if (this.$appConfig.active === 'prod') {
        window.open('https://t.speakstreet.cn/?tchId=' + this.formData.id + '&tchName=' + this.formData.firstName + '' + this.formData.lastName, '_blank')
      } else {
        window.open('https://test-t.kouyujie.cn/?tchId=' + this.formData.id + '&tchName=' + this.formData.firstName + '' + this.formData.lastName, '_blank')
      }
    },
    editContract () {
      const currentPath = this.$route.path // 当前页面路径
      const currentQuery = this.$route.query // 当前页面的查询参数

      window.open(this.$router.resolve({path: '/tch-contract',
        query: {
          from: encodeURIComponent(currentPath), // 编码路径
          ...currentQuery, // 合并当前查询参数
          tchId: this.tchId, // 使用 prop tchId，放在最后防止被 currentQuery 覆盖
        }}).href, '_blank')
    },
    deleteUrl (type) {
      if (type === 'TESOL') {
        this.formData.certificateTesol = ''
        this.certificateTesolUrl = ''
        this.certificateTesolUrlList = []
        this.$Message.success('TESOL 删除成功!')
      } else if (type === 'TESOLOut') {
        this.formData.certificateTesolOut = ''
        this.certificateTesolOutUrl = ''
        this.certificateTesolOutUrlList = []
        this.$Message.success('TESOL 删除成功!')
      } else if (type === 'TEFL') {
        this.formData.certificateTefl = ''
        this.certificateTeflUrl = ''
        this.certificateTeflUrlList = []
        this.$Message.success('TEFL 删除成功!')
      } else if (type === 'TEFLOut') {
        this.formData.certificateTeflOut = ''
        this.certificateTeflOutUrl = ''
        this.certificateTeflOutUrlList = []
        this.$Message.success('TEFL 删除成功!')
      } else if (type === 'TEYL') {
        this.formData.certificateTeyl = ''
        this.certificateTeylUrl = ''
        this.certificateTeylUrlList = []
        this.$Message.success('TEYL 删除成功!')
      } else if (type === 'ENGLISH') {
        this.formData.certificateEnglish = ''
        this.certificateEnglishUrl = ''
        this.certificateEnglishUrlList = []
        this.$Message.success('英语证件 删除成功!')
      } else if (type === 'ENGLISHOut') {
        this.formData.certificateEnglishOut = ''
        this.certificateEnglishOutUrl = ''
        this.certificateEnglishOutUrlList = []
        this.$Message.success('英语证件 删除成功!')
      } else if (type === 'DOC') {
        this.formData.introduceDoc = ''
        this.introduceDocUrl = ''
        this.introduceDocUrlList = []
        this.$Message.success('介绍文档 删除成功!')
      } else if (type === 'VIDEO') {
        this.formData.introduceVideo = ''
        this.introduceVideoUrl = ''
        this.introduceVideoUrlList = []
        this.$Message.success('介绍视频 删除成功!')
      } else if (type === 'RESUME') {
        this.formData.resume = ''
        this.resume = ''
        this.resumeList = []
        this.$Message.success('简历 删除成功!')
      } else if (type === 'SELFINTRODUCTIONVIDEO') {
        this.formData.selfIntroductionVideo = ''
        this.selfIntroductionVideo = ''
        this.selfIntroductionVideoList = []
        this.$Message.success('自我介绍视频 删除成功!')
      } else if (type === 'TEACHVIDEO') {
        this.formData.teachVideo = ''
        this.teachVideo = ''
        this.teachVideoList = []
        this.$Message.success('上课片段 删除成功!')
      } else if (type === 'NATIONALITY_IMAGE') {
        this.formData.tchForm.nationalityImage = ''
        this.nationalityImageUrl = ''
        this.nationalityImageUrlList = []
        this.$Message.success('国籍图片 删除成功!')
      }
    },
    deleteImages (type, item) {
      if (type === 'IMAGES') {
        const index = this.images.indexOf(item)
        if (index !== -1) {
          this.images.splice(index, 1)
        }
      }
    },
    loadTchInfo () {
      let self = this
      if (self.tchId > 0) {
        self.formData.tchId = self.tchId
        self.tchTrackFormData.tchId = self.tchId
        self.queryParam.tchId = self.tchId
        if (self.tabName === '老师跟踪记录') {
          self.search()
        }
        self.$http.get('/tch/queryById?tchId=' + self.tchId).then(function (res) {
          if (res.data) {
            let data = res.data
            self.tchTrackFormData.tchName = data.firstName + ' ' + data.lastName
            self.tchTrackFormData.studyAdviserName = data.studyAdviserName
            self.$helper.copyProperties(data, self.formData)
            self.certificateTeflUrl = commonUtils.getTotalUrl(data.certificateTefl)
            self.certificateTesolUrl = commonUtils.getTotalUrl(data.certificateTesol)
            self.certificateTeflOutUrl = commonUtils.getTotalUrl(data.certificateTeflOut)
            self.certificateTesolOutUrl = commonUtils.getTotalUrl(data.certificateTesolOut)
            self.certificateTeylUrl = commonUtils.getTotalUrl(data.certificateTeyl)
            self.certificateEnglishUrl = commonUtils.getTotalUrl(data.certificateEnglish)
            self.certificateEnglishOutUrl = commonUtils.getTotalUrl(data.certificateEnglishOut)
            self.introduceDocUrl = commonUtils.getTotalUrl(data.introduceDoc)
            self.introduceVideoUrl = commonUtils.getTotalUrl(data.introduceVideo)
            self.nationalityImageUrl = commonUtils.getTotalUrl(data.tchForm.nationalityImage)
            self.selfIntroductionVideo = commonUtils.getTotalUrl(data.selfIntroductionVideo)
            self.resume = commonUtils.getTotalUrl(data.resume)
            self.teachVideoList = data.teachVideoList
            if (data.features) {
              self.formData.features = data.features
              self.featuresArray = data.features.split(',')
            }
            if (data.suitableLevel) {
              self.formData.suitableLevel = data.suitableLevel
              self.levelArray = data.suitableLevel.split(',')
            }
            if (data.images) {
              self.images = data.images.split(',')
            }
            self.fillPolishLessonVideoList(data.polishLessonVideos)

            // 加载课表数据
            if (data.workTimes && data.workTimes.length > 0) {
              self.workTimeSelections = {}
              data.workTimes.forEach(wt => {
                // 转换时间格式 (18:00 -> 6:00pm)
                const convertTime = (timeStr) => {
                  let [hour, minute] = timeStr.split(':')
                  let hourNum = parseInt(hour)
                  let period = 'am'

                  if (hourNum >= 12) {
                    period = 'pm'
                    if (hourNum > 12) {
                      hourNum -= 12
                    }
                  } else if (hourNum === 0) {
                    hourNum = 12
                  }

                  return `${hourNum}:${minute}${period}`
                }

                const startTime = convertTime(wt.startTime)
                const endTime = convertTime(wt.endTime)
                const key = `${wt.week}-${startTime}-${endTime}`
                self.$set(self.workTimeSelections, key, wt.status)
              })
            }

            if (data.avatar) {
              if (data.avatar.indexOf('http://') !== -1 || data.avatar.indexOf('https://') !== -1) {
                self.totalImageUrl = data.avatar
              } else {
                if (data.avatar.substr(0, 1) === '/') {
                  self.totalImageUrl = 'https://medias.kouyujie.cn' + data.avatar
                } else {
                  self.totalImageUrl = 'https://medias.kouyujie.cn/' + data.avatar
                }
              }
              self.text = '编辑头像'
            } else {
              self.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
              self.text = '上传头像'
            }
            self.seeTchTrack = data.seeTchTrack
          }
        })
      }
    },
    beforeUploadIntroduceVideoUrl (file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$Message.error('文件大小不能超过500M!')
        this.introduceVideoUrlList = []
        return false
      } else {
        this.beforeUp()
        return true
      }
    },
    beforeUploadIntroductionVideo (file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$Message.error('文件大小不能超过500M!')
        this.selfIntroductionVideoList = []
        return false
      } else {
        this.beforeUp()
        return true
      }
    },
    beforeUploadTeachVideo (file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$Message.error('文件大小不能超过500M!')
        this.teachVideoList = []
        return false
      } else {
        this.beforeUp()
        return true
      }
    },
    beforeUploadTeachImages (file) {
      if (file.size > 31457280) {
        this.$Message.error('文件大小不能超过30M!')
        this.teachImagesList = []
        return false
      } else {
        this.beforeUp()
        return true
      }
    },
    beforeUpload (file) {
      this.beforeUp()
      return true
    },
    beforeUp () {
      this.headers.token = this.$store.get('token')
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account')
        this.headers.password = this.$store.get('password')
      }
      this.$Message.loading('服务器正在处理中...', 0)
    },
    handleProgress (event, file, fileList) {
      if (event.percent === 100) {
        event.percent = 99
      }
    },
    onLoading2 (loading) {
      this.searchLoading = loading
    },
    onSelection (selection) {
      this.selection = selection
    },
    saveTrackRecord () {
      let self = this
      this.searchLoading = true
      self.$refs.tchTrackRecordForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        self.searchLoading = true
        self.$http.post('/tchTrack/addTrackRecord', self.tchTrackFormData).then(function (res) {
          if (res && res.data > 0) {
            self.resetTrackRecord()
            self.$Message.success('提交成功!')
          }
          self.searchLoading = false
          self.search()
        }).catch(function (e) {
          self.searchLoading = false
          self.search()
        })
      })
    },
    resetTrackRecord () {
      this.tchTrackFormData.trackType = null
      this.tchTrackFormData.content = ''
      this.tchTrackFormData.picUrl = ''
      this.defaultPicsList = []
    },
    handleTrackFileChange (file, fileList) {
      this.defaultPicsList = fileList
      const names = fileList.filter(f => f.serverName).map(f => f.serverName).join(',')
      this.tchTrackFormData.picUrl = names
    },
    trackFileSuccess (res, file, fileList) {
      file.serverName = res.data.name
      const names = fileList.filter(f => f.serverName).map(f => f.serverName).join(',')
      this.tchTrackFormData.picUrl = names
    },
    beforeUploadTrackFile (file) {
      const isLt30M = file.size / 1024 / 1024 < 30

      if (!isLt30M) {
        this.$Message.error('文件大小不能超过30MB!')
        return false
      }

      this.headers.token = this.$store.get('token')
      if (this.$store.get('account') && this.$store.get('password')) {
        this.headers.account = this.$store.get('account')
        this.headers.password = this.$store.get('password')
      }
      this.$Message.loading('服务器正在处理中...', 0)
      return true
    },
    handleContentPaste (event) {
      const items = event.clipboardData && event.clipboardData.items
      if (!items) return

      for (let i = 0; i < items.length; i++) {
        if (items[i].type.startsWith('image/')) {
          event.preventDefault()
          const blob = items[i].getAsFile()
          const formData = new FormData()
          formData.append('file', blob, 'paste-' + Date.now() + '.png')
          formData.append('bucket', 'hellokid')

          this.$Message.loading('图片上传中...', 0)
          this.$http.post('/upload/fileUpload', formData, {
            transformRequest: [function (data) { return data }],
            headers: {
              'token': this.$store.get('token'),
              'account': this.$store.get('account') || '',
              'password': this.$store.get('password') || ''
            }
          }).then(res => {
            this.$Message.destroy()
            const data = res.data
            if (data && data.name) {
              const fileInfo = {
                name: data.name,
                url: data.url,
                status: 'success',
                serverName: data.name,
                percentage: 100,
                uid: Date.now()
              }
              this.defaultPicsList = [...this.defaultPicsList, fileInfo]
              const names = this.defaultPicsList.filter(f => f.serverName).map(f => f.serverName).join(',')
              this.tchTrackFormData.picUrl = names
              this.$Message.success('图片上传成功')
            }
          }).catch(() => {
            this.$Message.destroy()
            this.$Message.error('图片上传失败')
          })
          break
        }
      }
    },
    search () {
      this.queryParam.tchId = this.tchId
      this.reload = new Date().getTime()
    },
    handleModalScroll () {
      // sticky CSS 会自动处理固定，不需要 JS 干预
      console.log('Modal scrolled')
    },
    parseStatDate (value) {
      if (!value) {
        return new Date()
      }
      if (value instanceof Date) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate())
      }
      let text = String(value).replace(/-/g, '/')
      if (/^\d{4}$/.test(text)) {
        text = text + '/01/01'
      }
      if (text.length === 7) {
        text = text + '/01'
      }
      let d = new Date(text)
      if (isNaN(d.getTime())) {
        return new Date()
      }
      return new Date(d.getFullYear(), d.getMonth(), d.getDate())
    },
    calcStatRange () {
      let d = this.parseStatDate(this.statDate)
      this.statDate = d
      if (this.statPeriodType === 'day') {
        let day = dateFormat(d, 'YYYY-MM-DD')
        this.statStartDate = day
        this.statEndDate = day
        return
      }
      if (this.statPeriodType === 'week') {
        let weekDay = d.getDay()
        let mondayOffset = weekDay === 0 ? -6 : 1 - weekDay
        let monday = new Date(d.getFullYear(), d.getMonth(), d.getDate() + mondayOffset)
        let sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6)
        this.statStartDate = dateFormat(monday, 'YYYY-MM-DD')
        this.statEndDate = dateFormat(sunday, 'YYYY-MM-DD')
        return
      }
      if (this.statPeriodType === 'year') {
        let start = new Date(d.getFullYear(), 0, 1)
        let end = new Date(d.getFullYear(), 11, 31)
        this.statStartDate = dateFormat(start, 'YYYY-MM-DD')
        this.statEndDate = dateFormat(end, 'YYYY-MM-DD')
        return
      }
      let start = new Date(d.getFullYear(), d.getMonth(), 1)
      let end = new Date(d.getFullYear(), d.getMonth() + 1, 0)
      this.statStartDate = dateFormat(start, 'YYYY-MM-DD')
      this.statEndDate = dateFormat(end, 'YYYY-MM-DD')
    },
    resolveStatTchId () {
      return this.tchId || (this.tchTrackFormData && this.tchTrackFormData.tchId)
    },
    applyPersonalStat (data) {
      this.personalStat.leaveRate = data.leaveRate || '—'
      this.personalStat.leaveNumerator = data.leaveNumerator != null ? data.leaveNumerator : data.leaveTeacherCount
      this.personalStat.leaveDenominator = data.leaveDenominator != null ? data.leaveDenominator : data.taughtTeacherCount
      this.personalStat.tempLeaveRate = data.tempLeaveRate || '—'
      this.personalStat.tempLeaveCount = data.tempLeaveCount != null ? data.tempLeaveCount : null
      this.personalStat.tempLeaveBaseCount = data.tempLeaveBaseCount != null ? data.tempLeaveBaseCount : null
      this.personalStat.fullAttendanceRate = data.fullAttendanceRate || '—'
      this.personalStat.fullAttendanceCount = data.fullAttendanceCount != null
        ? data.fullAttendanceCount
        : data.fullAttendanceNumerator
      this.personalStat.fullAttendanceTotalCount = data.fullAttendanceTotalCount != null
        ? data.fullAttendanceTotalCount
        : data.fullAttendanceDenominator
      this.personalStat.lateRate = data.lateRate || '—'
      this.personalStat.lateCount = data.lateCount != null ? data.lateCount : null
      this.personalStat.lateBaseCount = data.lateBaseCount != null ? data.lateBaseCount : null
      this.personalStat.earlyRate = data.earlyRate || '—'
      this.personalStat.earlyCount = data.earlyCount != null ? data.earlyCount : null
      this.personalStat.earlyBaseCount = data.earlyBaseCount != null ? data.earlyBaseCount : null
      this.personalStat.returnLessonHours = data.returnLessonHours != null ? data.returnLessonHours : null
      this.personalStat.refundStudentCount = data.refundStudentCount != null ? data.refundStudentCount : null
      this.personalStat.demoAttendDealRate = data.demoAttendDealRate || '—'
      this.personalStat.demoAttendDealCount = data.demoAttendDealCount != null ? data.demoAttendDealCount : null
      this.personalStat.demoAttendCount = data.demoAttendCount != null ? data.demoAttendCount : null
      this.personalStat.attendLessonRate = data.attendLessonRate || '—'
      this.personalStat.attendLessonCount = data.attendLessonCount != null ? data.attendLessonCount : null
      this.personalStat.attendLessonBaseCount = data.attendLessonBaseCount != null ? data.attendLessonBaseCount : null
      this.personalStat.asOfTime = data.asOfTime || ''
    },
    formatStatFirstLastName (row) {
      const item = row || {}
      const first = (item.firstName || '').trim()
      const last = (item.lastName || '').trim()
      return (first + ' ' + last).trim()
    },
    statTeacherLabel (row) {
      if (!row) {
        return ''
      }
      let id = row.tchId == null ? '' : String(row.tchId)
      let first = (row.firstName || '').trim()
      let last = (row.lastName || '').trim()
      let name = (first + ' ' + last).trim() || (row.tchName || '').trim()
      return name ? (id + '-' + name) : id
    },
    openStatDetail (item) {
      if (!item || !item.metric) {
        return
      }
      this.calcStatRange()
      if (!this.statStartDate || !this.statEndDate) {
        this.$Message.error('请先选择统计时间')
        return
      }
      if (!this.resolveStatTchId()) {
        this.$Message.error('老师ID不能为空')
        return
      }
      this.statDetailMetric = item.metric
      this.statDetailSplit = !!item.split
      this.statDetailLeftTitle = item.leftTitle || '分子'
      this.statDetailLeftValue = item.leftValue == null ? '—' : String(item.leftValue)
      this.statDetailRightTitle = item.rightTitle || '分母'
      this.statDetailRightValue = item.rightValue == null ? '—' : String(item.rightValue)
      this.statDetailHasDiff = item.metric === 'fullAttendanceRate'
      this.statDetailDiffTitle = '未全勤课节'
      this.statDetailDiffValue = this.statFullAttendDiffText
      this.statDetailField = item.split ? '' : 'numerator'
      this.statDetailFieldTitle = item.split ? '' : item.title
      this.statDetailPageIndex = 1
      this.statDetailTableData = []
      this.statDetailTotal = 0
      this.showStatDetailModal = true
      if (!item.split) {
        this.loadStatDetail()
      }
    },
    openStatDetailField (field) {
      this.statDetailField = field
      if (field === 'numerator') {
        this.statDetailFieldTitle = this.statDetailLeftTitle
      } else if (field === 'denominator') {
        this.statDetailFieldTitle = this.statDetailRightTitle
      } else if (field === 'nonFullLessons') {
        this.statDetailFieldTitle = this.statDetailDiffTitle
      } else {
        this.statDetailFieldTitle = ''
      }
      this.statDetailPageIndex = 1
      this.statDetailTableData = []
      this.statDetailTotal = 0
      this.loadStatDetail()
    },
    backStatDetailCards () {
      this.statDetailField = ''
      this.statDetailFieldTitle = ''
      this.statDetailTableData = []
      this.statDetailTotal = 0
    },
    onStatDetailPageChange (page) {
      this.statDetailPageIndex = page
      this.loadStatDetail()
    },
    onStatDetailPageSizeChange (size) {
      this.statDetailPageSize = size
      this.statDetailPageIndex = 1
      this.loadStatDetail()
    },
    loadStatDetail () {
      if (!this.statDetailMetric || !this.statDetailField || !this.statStartDate || !this.statEndDate) {
        this.statDetailTableData = []
        this.statDetailTotal = 0
        return
      }
      let tchId = this.resolveStatTchId()
      if (!tchId) {
        return
      }
      this.statDetailLoading = true
      this.$http.post('/tch/hr-metrics-trend-detail', {
        metric: this.statDetailMetric,
        field: this.statDetailField,
        startDate: this.statStartDate,
        endDate: this.statEndDate,
        tchId: tchId,
        pageIndex: this.statDetailPageIndex,
        pageSize: this.statDetailPageSize
      }).then((res) => {
        if (res && res.status === 'ok' && res.data) {
          this.statDetailTableData = res.data.data || []
          this.loadMonthRankScores()
          this.statDetailTotal = res.data.totalCount || 0
        } else {
          this.statDetailTableData = []
          this.statDetailTotal = 0
          this.$Message.error((res && res.msg) || '明细加载失败')
        }
      }).catch(() => {
        this.statDetailTableData = []
        this.statDetailTotal = 0
        this.$Message.error('明细加载失败')
      }).finally(() => {
        this.statDetailLoading = false
      })
    },
    exportStatDetail () {
      if (this.statDetailSplit && !this.statDetailField) {
        this.$Message.warning(this.statDetailHasDiff ? '请先点开分子、分母或未全勤课节' : '请先点开分子或分母')
        return
      }
      this.calcStatRange()
      let tchId = this.resolveStatTchId()
      if (!this.statDetailMetric || !this.statDetailField || !this.statStartDate || !this.statEndDate || !tchId) {
        this.$Message.error('请先选择统计时间和老师')
        return
      }
      let names = {
        leaveRate: {numerator: '全部请假或老师缺席明细', denominator: '有课课节明细'},
        tempLeaveRate: {numerator: '临时请假失联取消课或缺席明细', denominator: '有课课节明细'},
        fullAttendanceRate: {numerator: '全勤课节明细', denominator: '有课课节明细', nonFullLessons: '未全勤课节明细'},
        lateRate: {numerator: '迟到课节明细', denominator: '正常上课课节明细'},
        earlyRate: {numerator: '早退课节明细', denominator: '正常上课课节明细'},
        attendLessonRate: {numerator: '已上课课节明细', denominator: '买断临时课节明细'},
        returnLessonHours: {numerator: '返课记录'},
        refundStudentCount: {numerator: '退费学生'},
        demoAttendDealRate: {numerator: '成交学生明细', denominator: '出席学生明细'}
      }
      let file = this.fileNameWithRange(
        ((names[this.statDetailMetric] || {})[this.statDetailField] || '数据统计明细'),
        this.statStartDate,
        this.statEndDate
      )
      this.statDetailExportLoading = true
      this.downloadStatExcel('/tch/hr-metrics-trend-detail-export', {
        metric: this.statDetailMetric,
        field: this.statDetailField,
        startDate: this.statStartDate,
        endDate: this.statEndDate,
        tchId: tchId
      }, file).finally(() => {
        this.statDetailExportLoading = false
      })
    },
    downloadStatExcel (url, data, filename) {
      return this.$http({
        method: 'post',
        url: url,
        data: data,
        responseType: 'arraybuffer'
      }).then((response) => {
        if (response && response.data) {
          const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          const link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click()
          window.URL.revokeObjectURL(link.href)
        } else {
          this.$Message.error('导出失败')
        }
      }).catch(() => {
        this.$Message.error('导出失败')
      })
    },
    fileNameWithRange (name, start, end) {
      let a = start || ''
      let b = end || ''
      let time = a
      if (b && b !== a) {
        time = a + '-' + b
      }
      return name + time + '.xlsx'
    },
    escapeExcelCell (value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    exportPersonalStat () {
      this.calcStatRange()
      if (!this.statStartDate) {
        this.$Message.error('请先选择统计时间')
        return
      }
      this.statExportLoading = true
      try {
        let tchId = this.resolveStatTchId() || ''
        let first = this.formData && this.formData.firstName ? String(this.formData.firstName).trim() : ''
        let last = this.formData && this.formData.lastName ? String(this.formData.lastName).trim() : ''
        let tchName = (first + ' ' + last).trim()
        if (!tchName && this.tchTrackFormData && this.tchTrackFormData.tchName) {
          tchName = String(this.tchTrackFormData.tchName).trim()
        }
        let html = '<html><head><meta charset="UTF-8"></head><body><table>'
        html += '<tr><th>外教ID</th><th>外教名字</th><th>指标</th><th>数值</th><th>说明</th></tr>'
        this.statCards.forEach((item) => {
          html += '<tr><td>' + this.escapeExcelCell(tchId) + '</td><td>' +
            this.escapeExcelCell(tchName) + '</td><td>' +
            this.escapeExcelCell(item.title) + '</td><td>' +
            this.escapeExcelCell(item.value) + '</td><td>' +
            this.escapeExcelCell(item.sub) + '</td></tr>'
        })
        html += '</table></body></html>'
        let blob = new Blob(['\uFEFF' + html], {type: 'application/vnd.ms-excel;charset=utf-8'})
        let link = document.createElement('a')
        link.target = '_blank'
        link.href = window.URL.createObjectURL(blob)
        link.download = this.fileNameWithRange('数据统计', this.statStartDate, this.statEndDate)
        link.click()
        window.URL.revokeObjectURL(link.href)
      } finally {
        this.statExportLoading = false
      }
    },
    loadPersonalStat () {
      let tchId = this.resolveStatTchId()
      if (!tchId) {
        return
      }
      this.calcStatRange()
      this.statLoading = true
      this.$http.post('/tch/hr-metrics-personal', {
        tchId: tchId,
        periodType: this.statPeriodType,
        startDate: this.statStartDate,
        endDate: this.statEndDate
      }).then((res) => {
        if (res && res.status === 'ok') {
          this.applyPersonalStat(res.data || {})
        } else {
          this.$Message.error((res && res.msg) || '加载失败')
        }
        this.statLoading = false
      }).catch(() => {
        this.$Message.error('加载失败')
        this.statLoading = false
      })
    },
    onStatPeriodChange () {
      this.calcStatRange()
      this.loadPersonalStat()
    },
    onStatDateChange (value) {
      this.statDate = this.parseStatDate(value)
      this.calcStatRange()
      this.loadPersonalStat()
    },
    initColorBlockRange () {
      let week = new Date().getDay()
      let left = week
      let right = 49 - week
      if (week === 0) {
        left = 7
      }
      let now = Date.now()
      let start = dateFormat(new Date(now - (left + 6) * 24 * 60 * 60 * 1000), 'YYYY-MM-DD')
      let end = dateFormat(new Date(now + right * 24 * 60 * 60 * 1000), 'YYYY-MM-DD')
      this.dateRange = [start, end]
    },
    onColorDateChange (value) {
      if (!value || value.length < 2 || !value[0] || !value[1]) {
        return
      }
      let start = dates.format(value[0], 'YYYY-MM-DD')
      let end = dates.format(value[1], 'YYYY-MM-DD')
      let currentStart = this.dateRange[0] ? dates.format(this.dateRange[0], 'YYYY-MM-DD') : ''
      let currentEnd = this.dateRange[1] ? dates.format(this.dateRange[1], 'YYYY-MM-DD') : ''
      if (start !== currentStart || end !== currentEnd) {
        this.dateRange = [start, end]
      }
      this.loadColorBlock()
    },
    loadColorBlock () {
      let self = this
      if (!this.dateRange || this.dateRange.length < 2 || !this.dateRange[0] || !this.dateRange[1]) {
        return
      }
      let tchId = this.tchTrackFormData.tchId
      let startTime = dates.format(this.dateRange[0])
      let endTime = dates.format(this.dateRange[1])
      if (!tchId || !startTime || !endTime) {
        return
      }
      let key = tchId + '|' + startTime + '|' + endTime
      if (key === this.colorBlockReqKey) {
        return
      }
      this.colorBlockReqKey = key
      let seq = ++this.colorBlockSeq
      this.queryParams.tchId = tchId
      this.queryParams.startTime = startTime
      this.queryParams.endTime = endTime
      self.$http.get('/teacherSchedule/queryTeacherDateSchedule', {params: this.queryParams}).then(res => {
        if (seq !== self.colorBlockSeq) {
          return
        }
        if (res.data) {
          self.dataList = res.data.map(item => {
            let row = item.teacherDateDetailScheduleDtoList
            let dateStr = item.dateStr
            let week = dates.toWeek(item.week)
            row.week = item.week
            row.title = `${week}(${dateStr})`
            row.dateStr = dateStr
            return row
          })
        }
      }).catch(() => {
        if (self.colorBlockReqKey === key) {
          self.colorBlockReqKey = ''
        }
      })
    },
    onTabClick (name) {
      // sticky CSS 会自动处理，不需要额外操作
      if (name === '老师跟踪记录') {
        this.queryParam.tchId = this.tchId
        this.search()
        return
      }
      if (name === '数据统计') {
        this.loadPersonalStat()
        return
      }
      if (name === '推荐官') {
        this.loadReferrerTab()
        return
      }
      if (name === '开课Checklist') {
        this.loadOnboardingDetail()
        return
      }
      if (name === '色块表') {
        this.initColorBlockRange()
        this.colorBlockReqKey = ''
        this.loadColorBlock()
        return
      }
      if (name === '在绑学生' && this.seeStuList) {
        this.reloadStuList = new Date().getTime()
      }
    },

    loadReferrerInfo () {
      let self = this
      if (!self.tchId) {
        self.referrerTabVisible = false
        self.referrerDetail = {}
        return
      }
      self.$http.get('/referrer/info/getByTchId', {params: {tchId: self.tchId}}).then(function (res) {
        let info = res && res.data ? res.data : {}
        self.referrerTabVisible = !!info.referrerId
        self.referrerDetail = self.referrerTabVisible ? info : {}
      }).catch(function () {
        self.referrerTabVisible = false
        self.referrerDetail = {}
      })
    },
    loadReferrerTab () {
      let self = this
      if (!self.referrerDetail || !self.referrerDetail.referrerId) {
        return
      }
      let referrerId = self.referrerDetail.referrerId
      self.referrerMonthlyLoading = true
      self.$http.get('/referrer/info/detail', {params: {referrerId: referrerId}}).then(function (res) {
        if (res && res.data) {
          self.referrerDetail = res.data
        }
      })
      self.$http.get('/referrer/info/monthlyStats', {params: {referrerId: referrerId}}).then(function (res) {
        self.referrerMonthlyStats = res && res.data ? res.data : []
      }).finally(function () {
        self.referrerMonthlyLoading = false
      })
    },

    loadOnboardingDetail () {
      let self = this
      if (!self.tchId) {
        return
      }
      self.onboardingLoading = true
      self.onboardingRows = []
      self.onboardingDoneCount = 0
      self.onboardingTotalCount = 0
      self.onboardingVersionId = null
      self.$http.get('/tchOnboarding/detail', {params: {tchId: self.tchId}}).then(function (res) {
        if (!res || res.status !== 'ok' || !res.data) {
          return
        }
        let data = res.data
        let stages = data.stages || []
        self.onboardingRows = self.buildOnboardingRows(stages)
        self.onboardingVersionId = data.versionId || null
        let done = 0
        let total = 0
        stages.forEach(function (stage) {
          done += stage.doneCount || 0
          total += stage.totalCount || 0
        })
        self.onboardingDoneCount = done
        self.onboardingTotalCount = total
      }).catch(function () {
        self.onboardingRows = []
        self.onboardingDoneCount = 0
        self.onboardingTotalCount = 0
        self.onboardingVersionId = null
      }).then(function () {
        self.onboardingLoading = false
      })
    },
    buildOnboardingRows (stages) {
      let rows = []
      let list = stages || []
      list.forEach(function (stage) {
        let items = stage.items || []
        items.forEach(function (item) {
          rows.push({
            stageName: stage.name,
            title: item.title,
            done: item.done,
            textValue: item.textValue,
            photoUrls: item.photoUrls
          })
        })
      })
      return rows
    },
    parseOnboardingPhotoUrls (photoUrls) {
      if (!photoUrls) {
        return []
      }
      if (Array.isArray(photoUrls)) {
        return photoUrls.map(function (url) {
          return (url || '').trim()
        }).filter(function (url) {
          return !!url
        })
      }
      return String(photoUrls).split(',').map(function (url) {
        return url.trim()
      }).filter(function (url) {
        return !!url
      })
    },
    renderOnboardingPhotos (h, photoUrls) {
      let urls = this.parseOnboardingPhotoUrls(photoUrls)
      if (!urls.length) {
        return h('span', '-')
      }
      let images = urls.map(url => {
        return h('img', {
          attrs: {src: url},
          style: {
            width: '48px',
            height: '48px',
            objectFit: 'cover',
            marginRight: '4px',
            borderRadius: '3px',
            cursor: 'pointer'
          },
          on: {click: () => window.open(url, '_blank')}
        })
      })
      return h('div', images)
    },

    crtBeginTimeDateChange (value) {
      this.formData.crtBeginTime = value && new Date(value)
    },
    crtEndTimeDateChange (value) {
      this.formData.crtEndTime = value && new Date(value)
    },
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.isAddTch = !(this.tchId > 0)
        this.saveType = this.addType
        if ((this.saveType === 'agency' || this.addType === 'agency') && this.isAddTch) {
          this.$nextTick(() => {
            this.formData.category = 6
          })
          this.formData.category = 6
        }
        this.loadDetailTabRules()
      }
      if (val && this.tchId) {
        this.loadTchInfo()
        this.loadReferrerInfo()
      }
    },
    visible (val) {
      if (val === false) {
        this.$helper.reset(this.formData)
        this.$refs['tchForm'].resetFields()
        this.formData.tchForm = {}
        this.featuresArray = []
        this.levelArray = []
        this.isEmail = false
        this.certificateTesolUrl = ''
        this.certificateTeflUrl = ''
        this.certificateTeylUrl = ''
        this.certificateEnglishUrl = ''
        this.certificateEnglishOutUrl = ''
        this.introduceDocUrl = ''
        this.introduceVideoUrl = ''
        this.nationalityImageUrl = ''
        this.certificateTesolOutUrl = ''
        this.certificateTeflOutUrl = ''
        this.selfIntroductionVideo = ''
        this.resume = ''
        this.resumeList = []
        this.certificateTeflOutUrlList = []
        this.certificateTesolOutUrlList = []
        this.certificateTesolUrlList = []
        this.certificateTeflUrlList = []
        this.certificateTeylUrlList = []
        this.certificateEnglishUrlList = []
        this.certificateEnglishOutUrlList = []
        this.introduceDocUrlList = []
        this.introduceVideoUrlList = []
        this.nationalityImageUrlList = []
        this.selfIntroductionVideoList = []
        this.images = []
        this.polishLessonVideoList = ['']
        this.workTimeSelections = {}
        this.resetTrackRecord()
        this.queryParam = { trackType: null, tchId: '' }
        this.tabName = '基本信息'
        this.referrerTabVisible = false
        this.referrerDetail = {}
        this.referrerMonthlyStats = []
        this.imageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
        this.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
        this.$emit('on-close')
      }
    },
    tchId (val) {
      if (val && val > 0) {
        this.isAddTch = false
        if (this.visible) {
          this.loadTchInfo()
          this.loadReferrerInfo()
          if (this.tabName === '老师跟踪记录') {
            this.search()
          }
        }
      }
    },
    showStuList (val) {
      this.seeStuList = val
    },
    addType (val) {
      this.saveType = val
      if (val === 'agency' && !this.tchId) {
        this.formData.category = 6
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TchInfoModal.vue?a830fde4